import React, { useCallback, useState } from "react";
import { numberOnly } from "../bin/common";
import { useMutation } from "@tanstack/react-query";
import { createSignUp, getCheckEmail, smsCert, smsSend } from "../library/api";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();

  const [currentModal, setCurrentModal] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [value, setValue] = useState({
    id: "",
    pw: "",
    pw2: "",
    name: "",
    email: "",
    phone: "",
    certKey: "",
  });
  const [valueCheck, setValueCheck] = useState({
    id: false,
    phone: false,
    certKey: false,
  });
  const [checkBox, setCheckBox] = useState({
    ag1: false,
    ag2: false,
    ag3: false,
    ag4: false,
    ag5: false,
    ag6: false,
    ag7: false,
  });
  const [checkAllBox, setAllCheckBox] = useState(false);
  const regeId = /^(?=.*[A-Za-z0-9])[A-Za-z0-9]{4,20}$/;
  const regEmail =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
  const regpassword =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+[\]{};':"\\|,.<>/?]{8,20}$/;

  // 이메일 중복 확인
  const { mutate: getCheckEmailMutate } = useMutation({
    mutationFn: getCheckEmail,
    mutationKey: ["getCheckEmail"],
    onSuccess: (data) => {
      if (data.existed) {
        alert("이미 사용중인 아이디 입니다");
      } else {
        alert("사용가능한 아이디 입니다");
        setValueCheck((prevState) => ({ ...prevState, id: true }));
      }
    },
    onError: (error) => {
      // TODO : 작업 다하면 삭제해야됨
      setValueCheck((prevState) => ({ ...prevState, id: true }));
      alert(error.response.data.message);
      throw error;
    },
  });
  // 문자 전송
  const { mutate: smsSendMutate } = useMutation({
    mutationFn: smsSend,
    mutationKey: ["smsSend"],
    onSuccess: (data) => {
      if (data.done) {
        alert("인증번호가 전송되었습니다");
        setValueCheck((prevState) => ({
          ...prevState,
          phone: true,
          certKey: false,
        }));
        setTimeout(() => {
          if (valueCheck.certKey === false) {
            setValue((prevState) => ({ ...prevState, certKey: "" }));
            setValueCheck((prevState) => ({
              ...prevState,
              phone: false,
              certKey: false,
            }));
          }
        }, 180000);
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      throw error;
    },
  });

  // 문자 인증번호 인증
  const { mutate: smsCertMutate } = useMutation({
    mutationFn: smsCert,
    mutationKey: ["smsCert"],
    onSuccess: (data) => {
      if (data.done) {
        alert("인증이 완료 되었습니다");
        setValueCheck((prevState) => ({ ...prevState, certKey: true }));
        return;
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      if (error.response.data.code === 406) {
        setValue((prevState) => ({ ...prevState, certKey: "" }));
      }
      throw error;
    },
  });

  // 회원가입
  const { mutate: createSignUpMutate } = useMutation({
    mutationFn: createSignUp,
    mutationKey: ["createSignUp"],
    onSuccess: (data) => {
      if (data.done) {
        alert("회원가입 완료했습니다");
        navigate("/login");
        return;
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      throw error;
    },
  });

  const handleAllCheckBox = (checked, name) => {
    setCheckBox({
      ag7: checked,
      ag6: checked,
      ag1: checked,
      ag3: checked,
      ag2: checked,
      ag5: checked,
      ag4: checked,
    });
    setAllCheckBox(checked);
  };

  const handleCheckBox = (checked, name) => {
    setCheckBox((prev) => ({
      ...prev,
      [name]: checked,
    }));

    // 모두 선택되었는지 확인 후 전체 선택 상태 업데이트
    const allChecked = Object.values({
      ...checkBox,
      [name]: checked,
    }).every(Boolean);
    setAllCheckBox(allChecked);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const ag1 = event.target.ag1.checked;
    const ag2 = event.target.ag2.checked;
    const ag3 = event.target.ag3.checked;
    const ag4 = event.target.ag4.checked;
    const ag5 = event.target.ag5.checked;
    const ag6 = event.target.ag6.checked;
    const ag7 = event.target.ag7.checked;
    if (!value.id) {
      alert("아이디를 입력해주세요");
      return;
    }
    if (!valueCheck.id) {
      alert("아이디 중복 확인해주세요");
      return;
    }

    if (!regpassword.test(value.pw)) {
      alert("비밀번호를 확인해주세요");
      return;
    }
    if (!regpassword.test(value.pw2)) {
      alert("비밀번호를 확인해주세요");
      return;
    }
    if (!value.pw || !value.pw2) {
      alert("비밀번호를 입력해주세요");
      return;
    }

    if (value.pw !== value.pw2) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!value.name) {
      alert("이름을 입력해주세요");
      return;
    }
    if (!value.email) {
      alert("이메일을 입력해주세요");
      return;
    }

    if (!regEmail.test(value.email)) {
      alert("이메일을 확인해주세요");
      return;
    }
    if (!value.phone) {
      alert("휴대폰 번호를 입력해주세요");
      return;
    }

    if (!valueCheck.phone) {
      alert("휴대폰 번호를 인증해주세요");
      return;
    }

    if (!value.certKey) {
      alert("인증번호를 입력해주세요");
      return;
    }
    if (value.certKey.length < 6) {
      alert("인증번호를 확인해주세요");
      return;
    }
    if (!valueCheck.certKey) {
      alert("인증번호를 인증해주세요");
      return;
    }

    if (!ag1 || !ag2 || !ag3 || !ag4 || !ag5) {
      alert("필수 선택 항목이 비어있습니다");
      return;
    }

    createSignUpMutate({
      partnersId: value.id,
      password: value.pw,
      partnersNm: value.name,
      phoneNum: value.phone,
      emailAddr: value.email,
      privacyAgree: ag6 ? "Y" : "N",
      mktingAgree: ag7 ? "Y" : "N",
    });
  };

  return (
    <>
      <main className="flex-grow container mx-auto px-4 py-16">
        <div className="max-w-md mx-auto md:w-[500px]">
          <h1 className="text-4xl font-extrabold text-center mb-2">회원가입</h1>
          <p className="text-center text-sm mb-10">
            가입하려는 회원정보를 입력해주세요.
          </p>
          <form
            id="joinForm"
            className="flex flex-col items-center justify-center"
            onSubmit={handleSubmit}
          >
            <div className="mb-2.5 w-full">
              <div className="flex gap-x-[10px]">
                <input
                  type="text"
                  placeholder="4~20자리 영문 또는 숫자"
                  maxLength={20}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                  onChange={(e) => {
                    setValue((prevState) => ({
                      ...prevState,
                      id: e.target.value,
                    }));
                    setValueCheck((prevState) => ({ ...prevState, id: false }));
                  }}
                />
                <button
                  type="button"
                  className={`w-40  text-white py-4 rounded-lg ${
                    valueCheck.id ? "bg-regal-blue" : "bg-teal-500"
                  } `}
                  onClick={(e) => {
                    e.preventDefault();
                    if (value.id === "") {
                      alert("아이디를 입력해주세요.");
                      return;
                    }
                    if (value.id !== "" && !regeId.test(value.id)) {
                      alert("아이디가 올바르지 않습니다.");
                      return;
                    }
                    console.log(value.id);
                    getCheckEmailMutate({ id: value.id });
                  }}
                >
                  중복 확인
                </button>
              </div>
              {!regeId.test(value.id) && (
                <p className="text-[#F22F2F] text-sm font-medium mt-3 mb-4">
                  아이디를 정확히 입력해주세요.
                </p>
              )}
            </div>
            <div className="mb-2.5 w-full">
              <input
                type="password"
                placeholder="영문, 숫자, 특수문자를 포함한 8~20자리"
                maxLength={20}
                className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none "
                onChange={(e) => {
                  setValue((prevState) => ({
                    ...prevState,
                    pw: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="mb-2.5 w-full">
              <input
                type="password"
                placeholder="비밀번호 확인"
                maxLength={20}
                className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                onChange={(e) => {
                  setValue((prevState) => ({
                    ...prevState,
                    pw2: e.target.value,
                  }));
                }}
              />
              {value.pw2 !== value.pw && (
                <p className="text-[#F22F2F] text-sm font-medium mt-1 float-left">
                  비밀번호가 일치하지 않습니다.
                </p>
              )}
            </div>
            <div className="mb-2.5 w-full">
              <input
                type="text"
                placeholder="이름"
                className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                onChange={(e) => {
                  setValue((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="mb-2.5 w-full">
              <input
                type="text"
                placeholder="이메일"
                className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                onChange={(e) => {
                  setValue((prevState) => ({
                    ...prevState,
                    email: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="mb-2.5 w-full">
              <div className="flex gap-x-[10px]">
                <input
                  type="text"
                  placeholder="휴대폰번호"
                  maxLength="12"
                  onChange={(event) => {
                    numberOnly(event);
                    setValue((prevState) => ({
                      ...prevState,
                      phone: event.target.value,
                      certKey: "",
                    }));
                    setValueCheck((prevState) => ({
                      ...prevState,
                      phone: false,
                      certKey: false,
                    }));
                  }}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                />
                <button
                  type="button"
                  className={`w-40  text-white py-4 rounded-lg ${
                    valueCheck.phone ? "bg-regal-blue" : "bg-teal-500"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (!value.phone) {
                      alert("휴대폰 번호를 입력해주세요");
                      return;
                    }
                    smsSendMutate(value.phone);
                    // setValueCheck(prevState => ({...prevState, phone: true, certKey: false}));
                  }}
                >
                  인증번호 전송
                </button>
              </div>
            </div>
            <div className="mb-10 w-full">
              <div className="flex gap-x-[10px]">
                <input
                  type="text"
                  placeholder="인증번호 6자리를 입력해주세요"
                  value={value.certKey}
                  maxLength="6"
                  onChange={(event) => {
                    numberOnly(event);
                    setValue((prevState) => ({
                      ...prevState,
                      certKey: event.target.value,
                    }));
                    setValueCheck((prevState) => ({
                      ...prevState,
                      certKey: false,
                    }));
                  }}
                  className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"
                />
                <button
                  type="button"
                  className={`w-40  text-white py-4 rounded-lg ${
                    valueCheck.certKey ? "bg-regal-blue" : "bg-teal-500"
                  } `}
                  onClick={(e) => {
                    e.preventDefault();

                    if (!value.phone) {
                      alert("휴대폰 번호를 입력해주세요");
                      return;
                    }

                    if (!valueCheck.phone) {
                      alert("휴대폰 번호를 인증해주세요");
                      return;
                    }

                    if (!value.certKey) {
                      alert("인증번호를 입력해주세요");
                      return;
                    }

                    if (value.certKey.length < 6) {
                      alert("인증번호를 확인해주세요");
                      return;
                    }

                    smsCertMutate({
                      phone_numb: value.phone,
                      cert_numb: value.certKey,
                    });

                    //   setValueCheck(prevState => ({...prevState, certKey: true}));
                  }}
                >
                  인증하기
                </button>
              </div>
            </div>
            <div className="w-full flex flex-col mb-10">
              <p className="font-bold text-base mb-3">가입 약관 동의</p>
              <div className="w-full flex flex-col border border-gray-300 rounded-lg p-4 md:p-7">
                <div className="flex justify-between mb-2 border-gray-200 border-b pb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="all_check"
                      id="all_check"
                      checked={checkAllBox}
                      onChange={(event) => {
                        handleAllCheckBox(event.target.checked, "all_check");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-lg font-bold">전체 선택</p>
                  </div>
                </div>

                <div className="flex justify-between mb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="ag1"
                      id="ag1"
                      checked={checkBox?.ag1}
                      onChange={(event) => {
                        handleCheckBox(event.target.checked, "ag1");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-sm">[필수] 만 14세 이상입니다</p>
                  </div>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="ag2"
                      id="ag2"
                      checked={checkBox?.ag2}
                      onChange={(event) => {
                        handleCheckBox(event.target.checked, "ag2");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-sm">[필수] 이용약관 동의</p>
                  </div>
                  <button
                    type="button"
                    onClick={(event) => {
                      event.preventDefault();
                      setModalOpen(true);
                      setCurrentModal("ag2");
                    }}
                  >
                    {/*<button @click="modalOpen = true; currentModal = 'ag2'" type="button">*/}
                    <img
                      src="/assets/right-arrow.png"
                      className="cursor-pointer"
                      width="25"
                      height="10"
                      alt="Open modal"
                    />
                  </button>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="ag3"
                      id="ag3"
                      checked={checkBox?.ag3}
                      onChange={(event) => {
                        handleCheckBox(event.target.checked, "ag3");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-sm">[필수] 전자금융거래 이용약관 동의</p>
                  </div>
                  {/* @click="modalOpen = true; currentModal = 'ag3'" type="button" */}
                  <button
                    type="button"
                    onClick={(event) => {
                      event.preventDefault();
                      setModalOpen(true);
                      setCurrentModal("ag3");
                    }}
                  >
                    <img
                      src="/assets/right-arrow.png"
                      className="cursor-pointer"
                      width="25"
                      height="10"
                      alt="Open modal"
                    />
                  </button>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="ag4"
                      id="ag4"
                      checked={checkBox?.ag4}
                      onChange={(event) => {
                        handleCheckBox(event.target.checked, "ag4");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-sm">[필수] 개인정보 수집 및 이용 동의</p>
                  </div>
                  <button
                    type="button"
                    onClick={(event) => {
                      event.preventDefault();
                      setModalOpen(true);
                      setCurrentModal("ag4");
                    }}
                  >
                    {/*<button @click="modalOpen = true; currentModal = 'ag4'" type="button" >*/}
                    <img
                      src="/assets/right-arrow.png"
                      className="cursor-pointer"
                      width="25"
                      height="10"
                      alt="Open modal"
                    />
                  </button>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="ag5"
                      id="ag5"
                      checked={checkBox?.ag5}
                      onChange={(event) => {
                        handleCheckBox(event.target.checked, "ag5");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-sm">[필수] 개인정보 제3자 제공 동의</p>
                  </div>
                  <button
                    type="button"
                    onClick={(event) => {
                      event.preventDefault();
                      setModalOpen(true);
                      setCurrentModal("ag5");
                    }}
                  >
                    {/*@click="modalOpen = true; currentModal = 'ag5'" type="button">*/}
                    <img
                      src="/assets/right-arrow.png"
                      className="cursor-pointer"
                      width="25"
                      height="10"
                      alt="Open modal"
                    />
                  </button>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="ag6"
                      id="ag6"
                      checked={checkBox?.ag6}
                      onChange={(event) => {
                        handleCheckBox(event.target.checked, "ag6");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-sm">
                      [선택] 마케팅 목적의 개인정보 수집 및 이용 동의
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={(event) => {
                      event.preventDefault();
                      setModalOpen(true);
                      setCurrentModal("ag6");
                    }}
                  >
                    <img
                      src="./assets/right-arrow.png"
                      className="cursor-pointer"
                      width="25"
                      height="10"
                      alt="Open modal"
                    />
                  </button>
                </div>
                <div className="flex justify-between mb-2">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name="ag7"
                      id="ag7"
                      checked={checkBox?.ag7}
                      onChange={(event) => {
                        handleCheckBox(event.target.checked, "ag7");
                      }}
                      className="mr-2 w-4 h-4 cursor-pointer"
                    />
                    <p className="text-sm">
                      [선택] 광고성 정보 수신 동의(이메일, SMS, SNS)
                    </p>
                  </div>
                  {/*<button @click="modalOpen = true; currentModal = 'ag7'" type="button">*/}
                  <button
                    type="button"
                    onClick={(event) => {
                      event.preventDefault();
                      setModalOpen(true);
                      setCurrentModal("ag7");
                    }}
                  >
                    <img
                      src="./assets/right-arrow.png"
                      className="cursor-pointer"
                      width="25"
                      height="10"
                      alt="Open modal"
                    />
                  </button>
                </div>
              </div>
              <p className="text-sm mt-2 text-gray-500">
                * 14세 미만은 회원 가입이 제한됩니다.
              </p>
            </div>
            <button
              type="submit"
              className="w-full bg-teal-500 font-extrabold text-lg text-white py-4 rounded-full hover:bg-teal-600 transition duration-300"
            >
              동의하고 가입하기
            </button>
          </form>
        </div>

        {modalOpen && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-500 bg-opacity-75 flex items-center justify-center">
            {currentModal === "ag2" && (
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[320px] w-full">
                <div className="bg-white py-5">
                  <div className="mt-3 text-left flex flex-col">
                    <div className="flex justify-between px-5">
                      <h3
                        className="text-base leading-6 font-extrabold"
                        id="modal-title"
                      >
                        이용약관 동의
                      </h3>
                      <button type="button" onClick={() => setModalOpen(false)}>
                        <img src="./assets/close.svg" />
                      </button>
                    </div>
                    <div className="border-b border-gray-300 my-5"></div>
                    <div className="mt-2 px-5 h-[320px] overflow-y-auto">
                      <p className="text-[12px]">
                        제1장 총칙
                        <br />
                        <br />
                        제 1 조 (목적)
                        <br />
                        이 약관은 일사 주식회사(이하 “회사”)가 운영하는
                        사이버몰에서 제공하는 서비스와 이를 이용하는 회원의
                        권리·의무 및 책임사항을 규정함을 목적으로 합니다.
                        <br />
                        <br />
                        제 2 조 (용어의 정의)
                        <br />
                        이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
                        그리고 여기에서 정의되지 않은 이 약관상의 용어의 의미는
                        일반적인 거래관행에 따릅니다. 1. “사이버몰”이란 회사가
                        상품 또는 용역 등(일정한 시설을 이용하거나 용역을
                        제공받을 수 있는 권리를 포함하며, 이하 “상품 등”)을
                        회원에게 제공하기 위하여 컴퓨터 등 정보통신설비를
                        이용하여 상품 등을 거래할 수 있도록 설정한 가상의
                        영업장(www.ilsaram.co.kr 등 회사가 운영하는 웹사이트 및
                        모바일 웹, 앱 등을 모두 포함)을 의미합니다. 2.
                        “회원”이라 함은 사이버몰에 회원등록을 한 자로서,
                        계속적으로 사이버몰에서 제공하는 서비스를 이용할 수 있는
                        자를 말하며, 회사의 별도 기준에 따라 구분되는 “일반
                        회원”과 “일사비즈 회원”을 통칭합니다.. 3. “일사비즈
                        회원”이라 함은 사업자로서 사업을 영위하고 있는 대표
                        개인을 의미하며, 회사가 정하는 별도의 가입절차를 통해
                        회원등록을 한 자로서, 계속적으로 사이버몰에서 제공하는
                        서비스를 이용할 수 있는 자를 말합니다. 4. “아이디(ID)”라
                        함은 회원의 식별과 서비스 이용을 위하여 회원이 설정하고
                        회사가 승인하여 등록된 전자우편주소를 말합니다. 5.
                        “비밀번호(PASSWORD)”라 함은 회원의 동일성 확인과 회원의
                        권익 및 비밀보호를 위하여 회원 스스로가 설정하여
                        사이버몰에 등록한 문자와 숫자 등의 조합을 말합니다. 6.
                        “마켓플레이스 서비스(MARKETPLACE SERVICE)”라 함은 회사가
                        사이버몰을 통하여 제공하는 통신판매중개 서비스 및 관련
                        부가서비스 일체를 말합니다. 7. “판매자”라 함은 “일사
                        서비스 이용 약관-사업자용”을 승인하고 회사와
                        마켓플레이스 서비스(MARKETPLACE SERVICE) 이용계약을
                        체결한 자 또는 마켓플레이스 서비스(MARKETPLACE
                        SERVICE)를 이용하여 실제로 상품을 판매하는 자를
                        말합니다. 8. “할인쿠폰”이라 함은 상품 등을 구매할 때나
                        사이버몰이 제공하는 서비스를 이용할 때 표시된 금액 또는
                        비율만큼 할인 받을 수 있는 쿠폰을 말합니다. 9. “일사캐시
                        등”이라 함은 일사캐시, 일사페이머니 등 일사페이㈜(이하
                        “일사페이”)가 발행ㆍ관리하는 선불식전자지급수단으로서
                        일사 및 회사와 계약한 제휴사에서 상품 등을 구매하고 그
                        대가를 지급하는 데 사용할 수 있는 지급수단을 말합니다.
                        10. “제휴사”란 회사와 계약을 체결하여 회원에게 상품 등을
                        거래하거나 각종 정보 및 혜택 등을 제공하거나 회원이
                        일사캐시 등을 사용, 교환할 수 있는 온라인 및 오프라인
                        업체를 의미합니다. 제휴사는 일사 및 회사가 제공하는 개별
                        서비스 홈페이지에 고지되어 있으며, 회사 및 제휴사의
                        사정에 따라 해지 또는 추가될 수 있습니다.
                        <br />
                        <br />
                        제 3 조 (약관의 명시와 설명 및 개정)
                        <br />
                        ① 회사는 이 약관의 내용과 상호 및 대표자 성명, 영업소
                        소재지 주소(소비자의 불만을 처리할 수 있는 주소를 포함),
                        전화번호, 모사전송번호, 전자우편주소, 사업자등록번호,
                        통신판매업신고번호, 개인정보관리책임자 등을 회원이 쉽게
                        확인할 수 있도록 사이버몰의 초기 서비스 화면에
                        게시합니다. 다만, 약관의 구체적 내용은 회원이 연결화면을
                        통하여 볼 수 있도록 할 수 있습니다. ② 회사는
                        『전자상거래 등에서의 소비자보호에 관한 법률』, 『약관의
                        규제에 관한 법률』, 『전자문서 및 전자거래기본법』,
                        『전자금융거래법』, 『전자서명법』, 『정보통신망
                        이용촉진 및 정보보호 등에 관한 법률』, 『소비자기본법』
                        등 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할
                        수 있습니다. ③ 회사가 약관을 개정할 경우에는 적용일자 및
                        개정사유를 명시하여 현행 약관과 함께 사이버몰의 화면에
                        그 적용일자 7일(다만, 회원에게 불리한 내용으로 변경하는
                        경우에는 30일) 이전부터 적용일자 전일까지 공지합니다. ④
                        제3항에 의해 변경된 약관은 관련 법령에 특별한 규정 기타
                        부득이한 사유가 없는 한 그 적용일자 이전으로 소급하여
                        적용되지 아니합니다. ⑤ 제3항에 따라 공지된 적용일자
                        이후에 회원이 명시적으로 거부의사를 표명하지 않을
                        경우에는 개정된 약관에 동의하는 것으로 간주하며, 변경된
                        약관에 동의하지 않는 회원은 회원 탈퇴를 요청할 수
                        있습니다. 제3항의 조치에도 불구하고 약관의 개정 사실을
                        알지 못함으로써 발생하는 회원의 피해에 대하여 회사는
                        책임을 지지 않습니다. ⑥ 회사는 제공하는 서비스 내의 개별
                        서비스에 대한 별도의 약관 또는 이용조건을 둘 수 있으며
                        개별 서비스에서 별도로 적용되는 약관에 대한 동의는
                        회원이 개별 서비스를 최초로 이용할 경우 별도의
                        동의절차를 거치게 됩니다. 이 경우 개별 서비스에 대한
                        이용약관 등이 이 약관에 우선합니다. ⑦ 이 약관에서 정하지
                        아니한 사항과 이 약관의 해석에 관하여는 『전자상거래
                        등에서의 소비자보호에 관한 법률』, 『약관의 규제에 관한
                        법률』, 공정거래위원회가 정하는 『전자상거래 등에서의
                        소비자 보호지침』 등 관련 법령 및 상관례에 따릅니다. ⑧
                        이 약관의 규정이 대한민국의 강행법규와 상충되는 경우에는
                        그 강행법규에 따릅니다. 이 경우 다른 조항의 효력에는
                        영향을 미치지 아니합니다.
                        <br />
                        <br />
                        제 4 조 (서비스의 제공 및 변경)
                        <br />
                        ① 회사는 다음 각 호와 같은 서비스를 제공합니다. 1.
                        전자상거래 서비스(통신판매중개서비스 포함) 및 이에 수반
                        되는 기타 서비스 2. 기타 회사가 정하는 서비스 또는 업무
                        ② 회사는 상품 등의 품절 또는 기술적 사양의 변경 등의
                        경우에는 장차 체결되는 계약에 의해 제공할 상품 등의
                        내용을 변경할 수 있습니다. 이 경우에는 변경된 상품 등의
                        내용을 명시하여 현재의 상품 등의 내용을 게시한 곳에 즉시
                        공지합니다. ③ 회사가 제공하기로 회원과 계약을 체결한
                        서비스의 내용을 상품 등의 품절 또는 기술적 사양의 변경
                        등의 사유로 변경할 경우에는 그 사유를 회원에게 통지
                        가능한 주소로 즉시 통지합니다.
                        <br />
                        <br />
                        제 5 조 (서비스의 중단)
                        <br />
                        ① 회사는 천재지변 또는 이에 준하는 불가항력, 컴퓨터 등
                        정보통신설비의 보수점검·교체, 고장, 통신의 두절 등의
                        사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할
                        수 있습니다. ② 회사는 제1항의 사유로 서비스의 제공이
                        일시적으로 중단됨으로 인하여 회원이 입은 손해에 대하여
                        배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는
                        경우에는 그러하지 아니합니다. ③ 사업 종목의 전환, 사업의
                        종료 또는 포기, 회사의 폐업, 합병, 분할, 영업양도 등의
                        이유로 서비스를 제공할 수 없게 되는 경우에는 회사는
                        제8조에 정한 방법으로 회원에게 통지하고 당초 회사에서
                        제시한 조건에 따라 회원에게 보상합니다.
                        <br />
                        <br />
                        제 6 조 (회원가입 등)
                        <br />
                        ① 회원 가입을 희망하는 자는 회사가 정한 가입양식에 따라
                        회원정보를 기입한 후 이 약관에 동의한다는 의사표시를
                        함으로써 회원가입을 신청합니다. ② 회사는 제1항과 같이
                        회원으로 가입할 것을 신청한 자 중 다음 각 호에 해당하지
                        않는 한 회원으로 등록합니다. 만약 회사가 회원가입신청의
                        승인을 거부하거나 유보하는 경우, 회사는 이를 제8조에
                        따라 회원에게 통지합니다. 1. 가입신청자가 이 약관 제7조
                        제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우
                        2. 회원의 요청에 의하여 탈퇴한 때로부터 1개월이 지나지
                        아니한 경우 3. 가입신청자가 기입한 회원정보에 명백한
                        허위 기재, 누락 또는 오기가 있는 경우 4. 회사가 본인확인
                        절차를 실시할 경우에 본인 확인이 되지 않거나 본인이
                        아님이 확인된 경우 5. 가입신청자가 만 14세 미만인 경우
                        6. 일사비즈 회원이 실제로 사업을 영위하고 있지 않음에도
                        허위 정보 및 서류 등을 이용하여 사업자 인증을 받은 경우
                        7. 일사비즈 회원의 성명, 주민등록번호, 사업자등록번호,
                        법인등록번호 및 기타 주요 등록 정보가 이미 등록된 다른
                        일사비즈 회원과 동일한 경우 8. 기타 가입신청자를
                        회원으로 등록하는 것이 사이버몰의 기술상 불가능하거나,
                        사이버몰의 운영 또는 유지·관리에 현저한 지장을 준다고
                        판단되는 경우 ③ 회원가입계약의 성립시기는 회사의 승낙이
                        가입신청자에게 도달한 시점으로 합니다. ④ 회원은
                        회원정보에 변경이 있는 경우, 회원정보 수정 등의 방법으로
                        그 변경사항을 반영하여야 합니다. 회원정보 수정을 하지
                        않음으로써 발생하는 회원의 손해에 대하여 회사는 아무런
                        책임을 지지 않습니다. ⑤ 회사는 『영화 및 비디오물의
                        진흥에 관한 법률』 및 『청소년 보호법』 및 『화학물질
                        관리법』등 관련 법령에 따른 등급 및 연령제한 준수를
                        위하여 회원의 서비스 이용 또는 상품 등 구매를
                        제한하거나, 회원에게 나이 및 본인확인 등의 절차를 요구할
                        수 있습니다
                        <br />
                        <br />
                        제 7 조 (회원 탈퇴 및 자격 상실 등)
                        <br />
                        ① 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며, 회사는
                        회원의 회원탈퇴 요청 즉시 회원탈퇴를 처리합니다.
                        회원탈퇴 시 회원자격이 상실되며, 회사가 제공하는 각종
                        할인쿠폰, 이벤트 혜택 등이 소멸됩니다. 단, 회원탈퇴 시
                        소진되지 않은 일사캐시 등이 있는 경우에 이에 대한 권리를
                        포기한 것으로 간주하여, 탈퇴와 동시에 전부 소멸됩니다.
                        다만, 회사의 상품대금 후불결제 서비스 이용요금을
                        결제하지 않은 경우, 탈퇴가 제한됩니다. ② 회원이 다음 각
                        호의 사유에 해당하는 경우, 회사는 회원의 자격을 제한
                        또는 상실시킬 수 있습니다. 1. 1. 회원정보에 허위 내용을
                        입력하거나 타인의 정보를 도용한 경우 2. 일사비즈 회원이
                        실제로 사업을 영위하고 있지 않거나, 사업의 영위를
                        중단(휴업/폐업 등 모두 포함)하였음에도 불구하고 계속하여
                        일사비즈 회원으로서 사이버몰을 이용하는 경우 3.
                        사이버몰을 이용하여 구입한 재화 등의 대금, 기타 사이버몰
                        이용과 관련하여 회원이 부담하는 채무를 기일에 지급하지
                        않는 경우 4. 다른 사람의 사이버몰 이용을 방해하거나 그
                        정보를 도용하는 등 전자상거래 질서를 위협하는 경우 5.
                        주소, 전자우편 등 회원정보를 잘못 입력하거나 변경하지
                        않는 등 회원의 귀책사유로 인하여 회사가 상당한 노력을
                        기울였음에도 불구하고 회원에게 통지 또는 연락을 할 수
                        없게 된 경우 6. 이 약관 제12조 회원의 의무를 위반하는
                        행위를 하는 경우 7. 이 약관의 규정 또는 회사의 이용정책
                        등을 위반하거나 법령 기타 공서양속에 반하는 행위를 하는
                        경우 ③ 회사가 회원 자격을 제한 시킨 후 동일한 행위가 2회
                        이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는
                        경우 회사는 회원 자격을 상실시킬 수 있습니다. ④ 회사가
                        회원 자격을 상실시키는 경우에는 회원 등록을 말소하며,
                        이때 회사는 거래 안전을 위하여 해당 회원의 소유로
                        확인되는 아이디의 회원 등록을 일괄 말소할 수 있습니다.
                        이 경우 회사는 이를 제8조에 따라 회원에게 통지하고, 회원
                        등록 말소 전 최소한 30일 이상의 기간을 정하여 소명할
                        기회를 부여합니다.
                        <br />
                        <br />
                        제 8 조 (회원에 대한 통지)
                        <br />
                        ① 회사가 회원에 대한 통지를 하는 경우, 회원이 회사와
                        미리 약정하여 지정한 방법에 따라 전자우편, SMS, 전화,
                        팩스 등으로 할 수 있습니다. ② 회사는 불특정다수 회원에
                        대한 통지의 경우 7일 이상 사이버몰의
                        공지사항(고객센터)에 게시함으로써 개별 통지에 갈음할 수
                        있습니다. 다만, 회원 본인의 거래에 관련하여 중대한
                        영향을 미치는 사항에 대하여는 개별 통지합니다.
                        <br />
                        <br />
                        제 9 조 (정보의 제공 및 광고의 게재)
                        <br />
                        ① 회사는 회원이 서비스 이용 중 필요하다고 인정되는
                        다양한 정보를 게시판에 공지하거나 전자우편이나 SMS,
                        전화, 앱푸쉬 등의 방법으로 회원에게 제공할 수 있습니다.
                        그리고 회원은 법령에 따라 회사에게 부과된 의무이행을
                        위한 절차안내, 고객문의 등에 대한 답변, 기타
                        거래관련정보 등을 제외하고는 언제든지 전자우편 등에
                        대해서 수신 거절을 할 수 있습니다. ② 회사는 서비스의
                        운영과 관련하여 서비스 화면, 전자우편 등에 광고를 게재할
                        수 있습니다. 광고가 포함된 전자우편 등을 수신한 회원은
                        수신거절을 할 수 있으며, 회사는 수신거절을 위한 방법을
                        회원에게 제공합니다.
                        <br />
                        <br />
                        제 10 조 (회사의 의무)
                        <br />
                        ① 회사는 이 약관이 금지하거나 관련 법령 기타 공서양속에
                        반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라
                        지속적이고, 안정적으로 서비스를 제공하는 데 최선을
                        다합니다. ② 회사는 회원이 안전하게 서비스를 이용할 수
                        있도록 회원의 개인정보(신용정보 포함)보호를 위한
                        보안시스템을 갖추어야 하며, 개인정보처리방침을 공시하고
                        준수합니다. ③ 회사는 회원이 동의하지 않는 영리목적의
                        광고성 전자우편, 앱푸쉬 등을 발송하지 않습니다. ④ 회사는
                        회원으로부터 제기되는 의견이나 불만이 객관적으로
                        정당하다고 인정될 경우에는 회원의 불만을 해결하기 위해
                        노력합니다.
                        <br />
                        <br />
                        제 11 조 (회원의 아이디 및 비밀번호에 대한 의무)
                        <br />
                        ① 아이디와 비밀번호에 관한 관리책임은 회원 본인에게
                        있습니다. ② 회원은 자신의 아이디 및 비밀번호를 제3자에게
                        제공, 공개하거나 제3자가 이용하도록 해서는 안 됩니다. ③
                        회원이 자신의 아이디 및 비밀번호의 유출 또는 제3자
                        사용에 대해 인지하고도 비밀번호를 변경하지 않은 경우
                        또는 이와 같은 사정을 회사에 통지 하지 않거나 회사의
                        조치에 응하지 않은 경우 등 회원이 본 조의 의무를
                        준수하지 않아 발생하는 모든 손실이나 손해 등 불이익에
                        대한 책임은 회원에게 있습니다. ④ 회원의 아이디(ID)와
                        비밀번호가 외부에 누출되었다고 의심되는 경우, 회사는
                        계정 잠금 등 보호조치를 취할 수 있으며 회원의 이용이
                        제한될 수 있습니다.
                        <br />
                        <br />
                        제 12 조 (회원의 의무)
                        <br />
                        ① 회원은 이 약관의 규정, 회사의 이용정책, 이용안내 사항
                        및 관련 법령 등을 준수하여야 하며, 기타 회사 업무에
                        방해되는 행위를 하여서는 안 됩니다. ② 회원은 다음 각
                        호의 행위를 하여서는 안 됩니다. 1. 회원이 회사가
                        제공하는 서비스를 이용하지 아니하고 판매자와 직접
                        거래하는 행위(이하 “직거래”) 또는 이를 유도하는 행위 2.
                        회사 또는 판매자의 판매 활동을 방해하거나 사이버몰을
                        이용하여 부당한 이득을 취하는 등 통상적인 전자상거래
                        관행에 부합하지 않는 거래상의 부정 행위 3. 상품의 판매
                        또는 용역의 제공을 가장한 현금 융통 등
                        『여신전문금융업법』, 『정보통신망 이용촉진 및 정보보호
                        등에 관한 법률』 및 기타 관계 법령에 위배되거나
                        비정상적인 결제 행위 4. 회사가 제공하는 서비스
                        이용방법에 의하지 아니하고 비정상적인 방법으로 서비스를
                        이용하거나 회사의 정보처리시스템에 접근하는 행위 5.
                        회사가 제공하는 서비스와 관련 없거나 비합리적인 요청,
                        공서양속에 반하는 행위 등으로 회사의 업무를 방해하는
                        행위 6. 기타 위 각 호에 준하여 회사 또는 제3자의 권리를
                        침해 또는 침해할 우려가 있거나, 전자상거래 질서를
                        위협하는 행위 ③ 회사는 제2항을 위반한 회원에 대하여 계약
                        해제, 일사캐시 등 또는 할인쿠폰의 환수, 회원 자격의
                        제한, 현금 환불 보류 등의 조치 및 민∙형사 상의 법적 조치
                        등을 취할 수 있습니다. ④ 본 조 제2항, 제3항의 구체적인
                        내용은 일사 서비스 이용 정책”에서 정합니다.
                        <br />
                        <br />
                        제 13 조 (개인정보보호)
                        <br />
                        ① 회사는 회원의 개인정보 수집 시 서비스 제공을 위하여
                        필요한 범위에서 최소한의 개인정보를 수집합니다. ② 회사는
                        회원가입 시 구매계약이행에 필요한 정보를 미리 수집하지
                        않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약
                        이전에 본인확인이 필요한 경우로서 최소한의 특정
                        개인정보를 수집하는 경우에는 그러하지 아니합니다. ③
                        회사는 회원의 개인정보를 수집·이용하는 때에는 당해
                        회원에게 그 목적을 고지하고 동의를 받습니다. ④ 회사는
                        수집된 개인정보를 목적 외의 용도로 이용할 수 없으며,
                        새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는
                        경우에는 이용·제공단계에서 당해 회원에게 그 목적을
                        고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이
                        있는 경우에는 예외로 합니다. ⑤ 회사가 제3항과 제4항에
                        의해 회원의 동의를 받아야 하는 경우에는 개인정보 관리
                        책임자의 신원(소속, 성명 및 전화번호, 기타 연락처),
                        정보의 수집목적 및 이용목적, 제3자에 대한 정보제공
                        관련사항(제공받은 자, 제공목적 및 제공할 정보의 내용) 등
                        『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 에서
                        규정한 사항을 미리 명시하거나 고지해야 하며 회원은
                        언제든지 이 동의를 철회할 수 있습니다. ⑥ 회원은 언제든지
                        회사가 가지고 있는 자신의 개인정보에 대해 열람 및 오류
                        정정을 요구할 수 있으며 회사는 이에 대해 지체 없이
                        필요한 조치를 취할 의무를 집니다. 회원이 오류의 정정을
                        요구한 경우에는 회사는 그 오류를 정정할 때까지 당해
                        개인정보를 이용하지 않습니다. ⑦ 회사는 개인정보 보호를
                        위하여 회원의 개인정보를 취급하는 자를 최소한으로
                        제한하여야 하며 신용카드, 은행계좌 등을 포함한 회원의
                        개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조
                        등으로 인한 회원의 손해에 대하여 모든 책임을 집니다. ⑧
                        회사 또는 그로부터 개인정보를 제공받은 제3자는
                        개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는
                        당해 개인정보를 지체 없이 파기합니다. ⑨ 회사는
                        개인정보의 수집·이용·제공에 관한 동의란을 미리 선택한
                        것으로 설정해두지 않습니다. 또한 개인정보의
                        수집·이용·제공에 관한 동의 거절 시 제한되는 서비스를
                        구체적으로 명시하고, 필수수집항목이 아닌 개인정보의
                        수집·이용·제공에 관한 회원의 동의 거절을 이유로 회원가입
                        등 서비스 제공을 제한하거나 거절하지 않습니다. ⑩ 회사의
                        사이버몰(제2조 제1호에서 정한 범위 내) 이외의 링크된
                        사이버몰에서는 회사의 개인정보처리방침이 적용되지
                        않습니다. 링크된 사이버몰 및 상품 등을 제공하는 제3자의
                        개인정보 취급과 관련하여서는 해당 사이버몰 및 제3자의
                        개인정보처리방침을 확인할 책임이 회원에게 있으며, 회사는
                        이에 대하여 책임을 부담하지 않습니다. ⑪ 회사는 다음과
                        같은 경우에 법이 허용하는 범위 내에서 회원의 개인정보를
                        제3자에게 제공할 수 있습니다. 1. 수사기관이나 기타
                        정부기관으로부터 적법한 절차에 따른 정보제공을 요청 받은
                        경우 2. 회원이 관련 법령을 위반하는 등의 부정행위를
                        확인하기 위해 필요한 경우 3. 판매자 또는 배송업체 등에게
                        거래 및 배송 등에 필요한 최소한의 회원의 정보(성명,
                        주소, 전화번호)를 제공하는 경우 4. 구매가 성사된 때에 그
                        이행을 위하여 필요한 경우와 구매가 종료된 이후에도 반품,
                        교환, 환불, 취소 등을 위하여 필요한 경우 5. 기타 관련
                        법령에 의해 요구되는 경우 ⑫ 기타 본 조에서 정하지 않은
                        사항은 회사가 마련한 “개인정보 처리방침”에 따릅니다.
                        <br />
                        <br />
                        제 14 조 (지급방법)
                        <br />
                        ① 사이버몰에서 구매한 상품 등에 대한 대금지급 방법은
                        다음 각 호의 방법 중 가용한 방법으로 할 수 있습니다. 1.
                        폰뱅킹, 인터넷뱅킹 등의 각종 계좌이체 2. 선불카드,
                        직불카드, 신용카드 등의 각종 카드 결제 3. 온라인
                        무통장입금 4. 전자화폐에 의한 결제 5. 수령 시 대금지급
                        6. 일사캐시 등에 의한 결제 7. 회사와 계약을 맺었거나
                        회사가 인정한 상품권에 의한 결제 8. 기타 전자적 지급
                        방법에 의한 대금 지급 등 ② 회원이 구매 대금의 결제와
                        관련하여 입력한 정보 및 그 정보와 관련하여 발생한 책임과
                        불이익은 전적으로 회원이 부담합니다. ③ 회사는 상품 등의
                        대금에 회원의 지급방법에 대한 수수료를 추가하여 징수할
                        수 없습니다. 다만, 회사는 상품대금 후불결제서비스 이용시
                        고지된 연체료 등 지연손해금을 회원에게 청구할 수
                        있습니다.
                        <br />
                        <br />
                        제 15 조 (할인쿠폰)
                        <br />
                        ① 할인쿠폰은 회사가 무상으로 발행하는 쿠폰으로 발행대상,
                        발행경로, 사용대상 등에 따라 구분될 수 있으며,
                        할인쿠폰의 세부구분, 할인금액(할인율), 사용방법,
                        사용기한 및 제한에 대한 사항은 할인쿠폰 또는 서비스
                        화면에 표시됩니다. 할인쿠폰의 종류 및 내용과 발급 여부는
                        회사의 서비스 정책에 따라 변경될 수 있습니다. ②
                        할인쿠폰은 현금으로 출금될 수 없으며, 할인쿠폰에 표시된
                        유효기간이 만료되거나 회원자격이 상실되면 소멸합니다. ③
                        할인쿠폰은 회사에서 별도로 명시한 경우를 제외하고는
                        타인에게 양도할 수 없으며, 부정한 목적이나 용도로 사용할
                        수 없습니다. 이를 위반한 경우 회사는 할인쿠폰을
                        소멸시키거나 회원자격을 제한 또는 상실시킬 수 있습니다.
                        ④ 회원이 부정한 방법으로 일사캐시 등 또는 할인쿠폰을
                        획득한 사실이 확인될 경우, 회사는 이를 회수하고,
                        회원자격 상실(아이디 삭제) 및 민∙형사 상의 법적 조치
                        등을 취할 수 있습니다.
                        <br />
                        <br />
                        제 16 조 (티켓서비스)
                        <br />
                        ① 티켓서비스란 회원이 일정한 시설을 이용하거나 용역을
                        제공받을 수 있는 권리를 상품으로 제공·판매하는 것을
                        말합니다. ② 회사는 회원이 티켓서비스를 이용할 수 있도록
                        티켓서비스 제공업체가 발행한 증거증권을 회원에게
                        판매합니다. ③ 회원은 티켓서비스 제공업체가 지정한
                        방법으로 본인확인 절차를 거쳐(단, 구매 확인 목적으로
                        전달되는 전자우편, 문자메시지, 기타 영수증으로는
                        본인확인을 대신할 수 없습니다), 개별조건 상에 명시된
                        유효기간 내에서만 티켓서비스를 이용할 수 있으며, 이를
                        타인에게 양도할 수 없습니다. ④ 미사용티켓 환불제 적용
                        상품의 경우, 회원은 유효기간 내에 이용하지 못한
                        티켓서비스의 구매 대금을 회사의 정책에 따라 일사캐시
                        등으로 환급 받을 수 있습니다. ⑤ 회원은 사이버몰에 명시된
                        내용 및 개별 주의사항(사용조건)을 확인하여야 할 책임이
                        있으며, 명시된 사용조건에 따라서만 티켓서비스를 이용하실
                        수 있습니다.
                        <br />
                        <br />
                        제 17 조 (모바일 상품권 등의 이용)
                        <br />
                        ① 회사는 제15조 및 제16조 등과 구별하여, 상품권을 구매한
                        회원이 언제든지 타인에게 양도할 수 있고, 소지만 하면
                        사용에 제한이 없는 전자적 형태의 온라인·모바일 상품권
                        등(이하 ‘모바일 상품권’이라 합니다)을 발행자로부터 제공
                        받아 회원에게 판매할 수 있습니다. 회원은 본 조의 모바일
                        상품권을 구매하였을 경우, 모바일 상품권에서 지정하는
                        바에 따라 발행자 또는 발행자가 지정한 다른 업체에서 이를
                        사용할 수 있습니다. ② 회원은 회사의 사이버몰에 명시된
                        내용 및 모바일 상품권에 기재된 주의사항을 확인하여야 할
                        책임이 있으며, 명시된 이용 조건에 따라 상품권을 사용할
                        수 있습니다. ③ 본 조에 따라 판매되는 모바일 상품권에
                        대해서는 이 약관에도 불구하고, 다음 각 호의 내용이
                        우선하는 것으로 합니다. 1. 회원이 모바일 상품권을 사용할
                        수 있는 유효기간은 공정거래위원회의 ‘신유형 상품권
                        표준약관(표준약관 제10073호, 이 약관 시행 이후 개정될
                        경우 그 개정약관을 가리키며, 이하 “상품권 표준약관”)
                        제5조에 따르며, 회원은 1회(3개월)이상 유효기간 연장을
                        발행자에게 요청할 수 있습니다. 2. 회원은 상품권 표준약관
                        제7조에 따라 모바일 상품권을 환불 받거나 일부 잔액을
                        반환 받을 수 있습니다. 3. 모바일 상품권의 표시사항,
                        지급보증 또는 피해보상보험계약 등 그 밖의 모바일
                        상품권에 관한 내용은 상품권 표준약관의 각 해당 내용에
                        따르며, 회원은 위 표준약관의 내용을 이 약관의 일부로
                        주장할 수 있습니다.
                        <br />
                        <br />
                        제 18 조 (일사캐시 등)
                        <br />
                        ① 회원은 사이버몰 혹은 회사의 제휴사에서 상품 등을
                        구매할 때 일사캐시 등을 결제 수단으로 사용할 수
                        있습니다. ② 회원이 일사캐시를 사용하기 위해서는
                        『일사페이 서비스 이용약관』, 『일사페이
                        전자금융거래이용약관』에 동의하여야 합니다. ③ 이벤트
                        또는 회사의 서비스 정책, 마케팅 및 프로모션을 통하여
                        지급되는 무상의 일사캐시 등의 유효기간은 각각 별도로
                        설정될 수 있으며, 유상의 일사캐시 등과 달리 환급의
                        대상이 되지 않습니다. ④ 회원은 무상의 일사캐시 등을 그
                        유효기간 이내에 사용하여야 하고, 유효기간 이내에
                        사용하지 않을 경우 소멸됩니다. 회사는 이벤트 등을 통해
                        무상으로 적립된 일사캐시 등의 적립 사유가 부존재하는
                        것으로 밝혀지거나 사후적으로 소멸한 경우 또는 회원
                        자격의 상실 시에는 이를 환수할 수 있습니다. ⑤ 일사캐시
                        등을 사용 시, 유효기간 만료일이 먼저 도래하는 일사캐시
                        등이 우선하여 사용됩니다.
                        <br />
                        <br />
                        제2장 전자상거래 서비스
                        <br />
                        <br />
                        제 1 절 리테일 서비스
                        <br />
                        <br />
                        제 19 조 (구매신청 및 개인정보 제공 동의 등)
                        <br />
                        ① 회원은 사이버몰 상에서 다음 또는 이와 유사한 방법에
                        의하여 구매를 신청하며, 회사는 회원이 구매신청을 함에
                        있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다. 1.
                        상품 등의 검색 및 선택 2. 받는 사람의 성명, 주소,
                        전화번호, 전자우편주소(또는 이동전화번호) 등의 입력 3.
                        약관내용, 청약철회권이 제한되는 서비스, 배송료, 설치비
                        등의 비용부담과 관련한 내용에 대한 확인 4. 이 약관에
                        동의하고 위 제3호의 사항을 확인하거나 거부하는 표시(예.
                        마우스 클릭) 5. 상품 등의 구매신청 및 이에 관한 확인
                        또는 회사의 확인에 대한 동의 6. 결제방법의 선택 ② 회사가
                        제3자에게 회원의 개인정보를 제공할 필요가 있는 경우 실제
                        구매신청 시 회원의 동의를 받아야 하며, 회원가입 시 미리
                        포괄적으로 동의를 받지 않습니다. 이때 회사는 제공되는
                        개인정보 항목, 제공받는 자, 제공받는 자의 개인정보
                        이용목적 및 보유·이용기간 등을 회원에게 명시하여야
                        합니다. ③ 회사가 제3자에게 회원의 개인정보
                        처리(개인정보의 수집, 생성, 연계, 연동, 기록, 저장,
                        보유, 가공, 편집, 검색, 출력, 정정(訂正), 복구, 이용,
                        제공, 공개, 파기(破棄), 그 밖에 이와 유사한 행위를 포함)
                        업무를 위탁할 필요가 있는 경우 실제 구매신청 시 회원의
                        동의를 받아야 하며, 회원가입 시 미리 포괄적으로 동의를
                        받지 않습니다. 이때 회사는 개인정보 처리위탁을 받는 자,
                        개인정보 처리위탁을 하는 업무의 내용 등을 회원에게
                        명시하여야 합니다. 다만, 『정보통신망이용촉진 및
                        정보보호 등에 관한 법률』에 달리 정함이 있는 경우에는
                        그에 따릅니다.
                        <br />
                        <br />
                        제 20 조 (계약의 성립)
                        <br />
                        ① 회사는 제19조와 같은 구매신청에 대하여 다음 각 호에
                        해당하면 계약을 승낙하지 않을 수 있습니다. 다만,
                        미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를
                        얻지 못하면 미성년자 본인 또는 법정대리인이 계약을
                        취소할 수 있다는 내용을 고지하여야 합니다. 1. 신청
                        내용에 허위, 기재누락, 오기가 있는 경우 2. 미성년자가
                        담배(전자담배 포함), 주류, 성인용품 등 청소년보호법에서
                        금지하는 재화 등을 구매하는 경우 3. 제7조에 따라 회원
                        자격이 제한 또는 상실된 회원이 구매신청 한 경우 4.
                        구매신청 회원이 재판매의 목적으로 상품 등을 중복
                        구매하는 등 사이버몰의 거래질서를 방해한 경우 5.
                        관할청의 처분 등으로 상품 등의 판매가 중단된 경우 6.
                        기타 구매신청에 승낙하는 것이 회사의 기술상 현저히
                        지장이 있다고 판단하는 경우 ② 회사의 승낙이 제21조
                        제1항의 수신확인통지 형태로 회원에게 도달한 시점에
                        계약이 성립한 것으로 봅니다. ③ 회사의 승낙의
                        의사표시에는 회원의 구매신청에 대한 확인 및 판매가능
                        여부, 구매신청의 정정, 취소 등에 관한 정보 등을
                        포함하여야 합니다. ④ 계약이 성립한 후 회사가 제1항 각
                        호의 사유를 발견한 경우 회사는 즉시 계약을 해제 또는
                        취소할 수 있으며, 계약 해제 또는 취소 시 회사는 회원이
                        상품 대금을 지급한 날로부터 3영업일 이내에 환급하거나
                        환급에 필요한 조치를 취합니다.
                        <br />
                        <br />
                        제 21 조 (수신확인통지·구매신청 변경 및 취소)
                        <br />
                        ① 회사는 회원의 구매신청이 있는 경우 회원에게
                        수신확인통지를 합니다. ② 수신확인통지를 받은 회원은
                        의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은
                        후 즉시 구매신청 변경 및 취소를 요청할 수 있고, 회사는
                        배송 전에 회원의 요청이 있는 경우에는 지체 없이 그
                        요청에 따라 처리하여야 합니다. 다만, 회원이 이미 대금을
                        지불한 경우에는 제24조의 청약철회 등에 관한 규정에
                        따릅니다.
                        <br />
                        <br />
                        제 22 조 (상품 등의 공급)
                        <br />
                        ① 회사는 회원과 상품 등의 공급시기에 관하여 별도의
                        약정이 없는 이상, 회원이 청약을 한 날로부터 7일 이내에
                        상품 등을 배송할 수 있도록 주문제작, 포장 등 기타의
                        필요한 조치를 취합니다. 다만, 회사가 이미 상품 등의
                        대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는
                        일부를 받은 날부터 3영업일 이내에 조치를 취합니다. 이때
                        회사는 회원이 상품 등의 공급절차 및 진행사항을 확인할 수
                        있도록 적절한 조치를 취합니다. ② 회사는 회원이 구매한
                        상품 등에 대해 배송수단, 수단별 배송비용, 부담자, 수단별
                        배송예상기간 등을 명시합니다. ③ 회사와 회원 간에 상품
                        등의 인도 또는 제공 시기에 관하여 별도의 약정이 있는
                        경우에는 해당 약정이 이 약관에 우선합니다.
                        <br />
                        <br />
                        제 23 조 (환급)
                        <br />
                        회사는 회원이 구매신청한 상품 등이 품절 등의 사유로 인도
                        또는 제공할 수 없을 때에는 지체 없이 그 사유를 회원에게
                        통지하고, 사전에 상품 등의 대금을 받은 경우에는 대금을
                        받은 날로부터 3영업일 이내에 환급하거나 환급에 필요한
                        조치를 취합니다.
                        <br />
                        <br />
                        제 24 조 (청약철회 등)
                        <br />
                        ① 회사와 상품 등의 구매에 관한 계약을 체결한 회원은
                        『전자상거래 등에서의 소비자보호에 관한 법률』 제13조
                        제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을
                        받은 때보다 상품 등의 공급이 늦게 이루어진 경우에는 상품
                        등을 공급받거나 상품 등의 공급이 시작된 날을 말함)부터
                        7일 이내에는 청약을 철회할 수 있습니다. 다만, 청약철회에
                        관하여 『전자상거래 등에서의 소비자보호에 관한 법률』에
                        달리 정함이 있는 경우에는 동 법 규정에 따릅니다. ②
                        회원은 상품 등을 배송 받은 경우 다음 각 호에 해당하는
                        경우에는 반품 및 교환을 할 수 없습니다. 1. 회원에게 책임
                        있는 사유로 상품 등이 멸실 또는 훼손된 경우(다만, 상품
                        등의 내용을 확인하기 위하여 포장 등을 훼손한 경우는
                        제외함) 2. 회원의 사용 또는 일부 소비에 의하여 상품 등의
                        가치가 현저히 감소한 경우 3. 시간의 경과에 의하여
                        재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한
                        경우 4. 복제 가능한 상품 등의 포장을 훼손한 경우 5.
                        회사가 상품 등의 청약철회 등의 제한에 관해 사전에 고지한
                        경우 6. 용역 또는 『문화산업진흥 기본법』 제2조 제5호의
                        디지털콘텐츠의 제공이 개시된 경우(다만, 가분적 용역 또는
                        가분적 디지털콘텐츠로 구성된 계약의 경우에는 제공이
                        개시되지 아니한 부분에 대하여는 제외함) 7. 주문에 따라
                        개별적으로 생산되는 상품 등 그에 대하여 청약철회 등을
                        인정할 경우 판매자에게 회복할 수 없는 중대한 피해가
                        예상되는 경우로서, 사전에 해당 거래에 대하여 별도로 그
                        사실을 고지하고 회원의 서면(전자문서를 포함)에 의한
                        동의를 받은 경우 ③ 회원은 제1항 및 제2항의 규정에도
                        불구하고 상품 등의 내용이 표시∙광고 내용과 다르거나
                        계약내용과 다르게 이행된 때에는 당해 상품 등을 공급받은
                        날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던
                        날부터 30일 이내에 청약철회 등을 할 수 있습니다. ④
                        회원은 제1항 또는 제3항에 따라 교환 신청을 하더라도
                        회사에 교환할 상품의 재고가 없는 경우에는 해당 상품 등의
                        교환을 받을 수 없습니다. 이 경우 해당 교환 신청은
                        반품으로 처리됩니다.
                        <br />
                        <br />
                        제 25 조 (청약철회 등의 효과)
                        <br />
                        ① 회사는 회원으로부터 상품 등을 반환 받은 경우 3영업일
                        이내에 이미 지급받은 상품 등의 대금을 환급합니다. 이
                        경우 회사가 회원에게 상품 등의 대금 환급을 지연한 때에는
                        그 지연기간에 대하여 『전자상거래 등에서의 소비자보호에
                        관한 법률 시행령』 제21조의3에서 정하는 지연이자율을
                        곱하여 산정한 지연이자를 지급합니다. ② 회사는 위 대금을
                        환급함에 있어서 회원이 신용카드 또는 전자화폐 등의
                        결제수단으로 상품 등의 대금을 지급한 때에는 지체없이
                        당해 결제수단을 제공한 사업자로 하여금 상품 등의 대금의
                        청구를 정지하거나 결제를 취소하도록 요청합니다. ③ 회사는
                        이미 상품 등이 일부 사용 또는 일부 소비된 경우에는 일부
                        소비에 의하여 회원이 얻은 이익 또는 그 상품 등의 공급에
                        소요된 비용에 상당하는 금액으로서 아래의 각 호에
                        해당하는 금액의 지급을 회원에게 청구할 수 있습니다. 1.
                        상품 등의 사용으로 인하여 소모성 부품의 재판매가
                        곤란하거나 재판매가격이 현저히 하락하는 경우에는 당해
                        소모성 부품의 공급에 소요된 비용 2. 다수의 동일한
                        가분물로 구성된 상품 등의 경우에는 회원의 일부 소비로
                        인하여 소비된 부분의 공급에 소요된 비용 ④ 청약철회 등의
                        경우 공급받은 상품 등의 반환에 필요한 제반 비용은 회원이
                        부담합니다. 회사는 회원에게 청약철회 등을 이유로 위약금
                        또는 손해배상을 청구하지 않습니다. 다만, 상품 등의
                        내용이 표시∙광고 내용과 다르거나 계약내용과 다르게
                        이행되어 청약철회 등을 하는 경우 상품 등의 반환에 필요한
                        비용은 회사가 부담합니다.
                        <br />
                        <br />
                        제 26 조 (반품 거절 및 반품 상품의 구매 등)
                        <br />
                        ① 회원이 제24조 제2항에 따라 반품 및 교환이 불가능한
                        상품 등(이하 “대상 상품”)을 회사에 반품한 경우 회사는
                        회사의 판단에 따라 회원의 반품을 거절하거나, 대상 상품의
                        판매가에 일정 비율을 계산한 금액(이하 “구매 비용”)을
                        지급하는 조건으로 해당 상품을 회사가 구매할 수 있습니다.
                        ② 회사가 제1항에 따라 구매를 결정하는 경우 회사는 반품된
                        대상 상품의 상태를 검수하여 구매 비용을 결정하고, 구매
                        비용은 원칙적으로 회원이 대상 상품의 대금을 지급하였던
                        원 결제 수단을 이용하여 지급합니다. ③ 구매 대상 상품 및
                        구매 비용 산정 기준, 구매 비용 지급 방식 등 세부적인
                        사항은 회사의 관련 웹페이지, 상품판매페이지 등을 통하여
                        공지합니다 제 2 절 마켓플레이스 서비스
                        <br />
                        <br />
                        제 27 조 (회원의 서비스 이용)
                        <br />
                        ① 마켓플레이스 서비스와 관련하여 회사는
                        통신판매중개자로서 회원과 판매자 간의 자유로운 상품 등의
                        거래를 위한 시스템을 운영 및 관리, 제공할 뿐이므로,
                        회원은 상품 등을 구매하기 전에 반드시 판매자가 사이버몰
                        내에 작성한 상품 등의 상세 내용과 거래의 조건을 정확하게
                        확인해야 합니다. 구매하려는 상품 등의 내용과 거래의
                        조건을 확인하지 않고 구매하여 발생한 모든 손해는 회원
                        본인이 부담합니다. ② 회원은 이 약관 및 회사가 서비스
                        화면에서 공지하는 내용을 준수하여야 하고, 이 약관 및
                        공지 내용을 위반하거나 이행하지 않아 발생하는 모든
                        손해에 대하여 책임을 집니다. ③ 회원은 판매자와 상품 등
                        매매 절차에서 분쟁이 발생하면 분쟁의 해결을 위하여
                        성실히 임해야 하며, 분쟁해결의 불성실로 판매자와 회사에
                        손해가 발생하면 그에 대한 모든 책임을 부담합니다. ④
                        회원은 매매대금의 결제와 관련하여 회원이 입력한 정보 및
                        그 정보와 관련하여 발생하는 제반 문제에 대한 모든 책임을
                        부담합니다. ⑤ 회사는 회원의 매매대금 결제 시 해당
                        결제수단에 대하여 정당한 사용권한이 있는지 확인할 수
                        있고, 이에 대한 확인이 완료될 때까지 해당 거래의 진행을
                        중지할 수 있습니다. ⑥ 회사는 회원에게 서비스가 안전하게
                        제공될 수 있도록 각종 설비와 자료를 관리하고, 서비스가
                        제공 목적에 맞게 이용되고 있는지 여부를 확인합니다. 만약
                        회원이 이용 목적을 위반한 것으로 확인되면 회사는 그에
                        대한 소명을 회원에게 요청할 수 있고, 주문 취소 등 필요한
                        조치를 할 수 있습니다. ⑦ 회원은 회사가 회원의 서비스
                        이용 편의를 위하여 판매자 등으로부터 제공 받은 상품 등
                        관련 정보 기타 콘텐츠를 사이버몰을 통하여 제공하는
                        경우에도 상품 등의 구매 여부는 전적인 회원 본인의 판단과
                        책임으로 결정하여야 합니다. 이 경우 회사는 회사의 고의
                        또는 중과실이 없는 한 회원의 구매 결정에 대하여 책임을
                        부담하지 아니 합니다. ⑧ 미성년자가 사이버몰을 통하여
                        상품 등을 구매하는 경우에 법정대리인이 해당 계약에
                        대하여 동의하지 아니하면, 미성년자 본인 또는
                        법정대리인은 그 계약을 취소할 수 있습니다 ⑨ 회사는 본
                        약관에 따른 전자지급결제대행, 결제대금예치,
                        선불전자지급수단의 발행 및 관리에 관한 제반업무를
                        전자금융거래법상 적법한 라이선스를 보유하고 있는
                        쿠팡페이를 이용하여 처리할 수 있습니다.
                        <br />
                        <br />
                        제 28 조 (결제대금예치서비스 이용)
                        <br />
                        ① “결제대금예치서비스”라 함은 매매계약이 체결되고 회원이
                        대금을 결제하는 경우에, 회원의 결제대금 보호를 위하여
                        회사가 일정 기간 동안 결제대금을 예치하는 서비스를
                        말합니다. ② 회사는 회원과 판매자 간에 이루어지는 상품 등
                        매매의 안전성과 신뢰성을 높이고, 상품 등을 인수하기 전에
                        대금을 결제해야 하는 회원을 보호하기 위하여
                        결제대금예치서비스를 제공합니다. ③ 회사는
                        결제대금예치서비스의 제공과 관련하여 판매자 또는 회원을
                        대리하는 것이 아님은 물론, 상품 등의 매매와 관련하여
                        판매자 또는 회원의 의무를 대행하는 것도 아닙니다. ④
                        회원은 결제대금예치서비스를 통하여 구매대금을 결제하는
                        과정에서 발생하는 송금수수료 등을 부담하여야 합니다. ⑤
                        회원은 회사가 결제대금예치서비스를 제공하는 과정에서
                        발생하는 이자 등에 대하여 회사에게 그 반환을 청구할 수
                        없습니다. ⑥ 결제대금예치서비스는 제29조에 정한 바에 따라
                        구매확정 된 경우에 종료됩니다. ⑦ 회원은
                        결제대금예치서비스가 종료된 이후에 해당 구매 건에 대하여
                        청약철회, 취소, 해제, 무효 등의 사유가 발생한 경우
                        판매자와 직접 청약철회, 취소, 해제 및 환불 등에 관한
                        절차를 진행해야 합니다.
                        <br />
                        <br />
                        제 29 조 (배송 및 거래완료)
                        <br />
                        ① 회사는 상품 등의 배송과 관련하여 판매자, 회원,
                        배송업체 등 관련 당사자 사이에 분쟁 등이 발생하는
                        경우에는 이에 관여하지 않으며 어떠한 책임도 부담하지
                        아니합니다. 이 경우 해당 분쟁 등은 관련 당사자가 직접
                        해결하여야 합니다. 다만, 회사는 관련 손해의 발생에
                        회사의 귀책사유가 있는 경우 법률에 따른 책임을
                        부담합니다. ② 회원은 구매한 상품 등의 배송이 완료되었을
                        때로부터 일정한 기간 내에 회사에 대하여 구매확정, 교환
                        또는 반품의 의사표시를 하여야 합니다. ③ 회사는 제2항의
                        구매확정 기간 내에 구매확정, 교환 또는 반품에 대한
                        회원의 의사표시가 없는 경우, 해당 거래에 대하여 회원의
                        구매확정 의사표시가 있는 것으로 간주하여
                        자동구매확정으로 처리할 수 있습니다. ④ 회원은 구매확정이
                        이루어진 경우에는 회사에 대하여 상품 등의 하자, 미수령,
                        반품 등의 사유로 이의를 제기할 수 없습니다. 구매확정
                        이후에 발생하는 환불, 교환 기타 판매자와 회원 간의 모든
                        문제는 거래 당사자인 판매자와 회원이 직접 해결해야 하며,
                        회사는 이에 개입하지 아니합니다.
                        <br />
                        <br />
                        제 30 조 (청약철회 등)
                        <br />
                        ① 회원은 『전자상거래 등에서의 소비자보호에 관한 법률』
                        등 관련 법령에 따라 상품 등을 배송 받은 날로부터 7일
                        이내에 청약철회 등을 할 수 있습니다. 다만, 청약철회에
                        관하여 『전자상거래 등에서의 소비자보호에 관한 법률』에
                        달리 정함이 있는 경우에는 동 법 규정에 따릅니다. ②
                        회원은 제1항에도 불구하고 다음 각 호에 해당하는 경우에는
                        반품이나 교환을 요청할 수 없습니다. 1. 회원의 책임 있는
                        사유로 상품 등이 멸실 또는 훼손된 경우(다만, 상품 등의
                        내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외함)
                        2. 회원의 사용 또는 일부 소비로 인하여 상품 등의 가치가
                        현저히 감소한 경우 3. 시간의 경과에 의하여 재판매가
                        곤란할 정도로 상품 등의 가치가 현저히 감소한 경우 4.
                        복제 가능한 상품 등의 포장을 훼손한 경우 5. 용역 또는
                        『문화산업진흥 기본법』 제2조 제5호의 디지털콘텐츠의
                        제공이 개시된 경우(다만, 가분적 용역 또는 가분적
                        디지털콘텐츠로 구성된 계약의 경우에는 제공이 개시되지
                        아니한 부분에 대하여는 제외함) 6. 주문에 따라 개별적으로
                        생산되는 상품 등 그에 대하여 청약철회 등을 인정할 경우
                        판매자에게 회복할 수 없는 중대한 피해가 예상되는
                        경우로서, 사전에 해당 거래에 대하여 별도로 그 사실을
                        고지하고 회원의 서면(전자문서를 포함)에 의한 동의를 받은
                        경우 7. 그 밖에 관련 법령에 따른 반품 제한 사유에
                        해당되는 경우 ③ 회원은 제1항 및 제2항에도 불구하고
                        상품의 내용이 표시∙광고 내용과 다르거나 계약내용과
                        다르게 이행된 경우에는 해당 상품 등을 공급받은 날부터
                        3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터
                        30일 이내에 청약철회 등을 할 수 있습니다. ④ 회사는
                        회원으로부터 교환 또는 반품의 의사표시를 받은 경우에는
                        즉시 그 사실을 판매자에게 통보합니다. ⑤ 회원은 제1항
                        또는 제3항에 따라 교환 신청을 하더라도 판매자에게 교환할
                        상품의 재고가 없는 경우에는 해당 상품 등의 교환을 받을
                        수 없습니다. 이 경우 해당 교환 신청은 반품으로
                        처리됩니다. ⑥ 반품이나 교환에 필요한 배송비 및 기타
                        비용은 귀책사유가 있는 당사자가 부담합니다. 이 경우 상품
                        등의 하자 또는 오배송으로 인한 반품이나 교환의 경우에는
                        판매자가 그 비용을 부담하나, 회원의 단순 변심으로 인한
                        반품이나 교환의 경우에는 회원이 그 비용을 부담합니다. ⑦
                        판매자는 회원이 배송상의 문제로 손해를 입은 경우에는
                        그에 대한 책임을 부담합니다. ⑧ 회사는 판매자가 회원의
                        결제완료에 대한 통지를 받은 이후에도 상당 기간 배송 절차
                        등을 이행하지 아니하여 회원이 청약철회 등을 하거나
                        개별적인 정책으로 미리 정한 자동환불처리 사안에 해당하는
                        경우에는 해당 거래를 취소하고 결제대금예치서비스 이용
                        중인 결제대금을 회원에게 환불할 수 있습니다. ⑨ 판매자가
                        회원의 교환 또는 반품 신청에 대하여 적극적으로 임하지
                        않거나 이를 지연하는 경우, 회사는 회원에게 그 교환 또는
                        반품 신청의 사유를 파악하여 정당한 사유가 있는 경우에는
                        해당 거래를 취소하는 한편, 예치 중인 결제대금을 회원에게
                        환불할 수 있습니다. 다만 회원의 교환 또는 반품신청에
                        정당한 사유가 없는 경우에는 그러하지 아니합니다. ⑩
                        회원이 교환 또는 반품신청을 한 날로부터 14일이 지날
                        때까지 이미 수령한 상품을 판매자에게 반환하지 아니
                        하거나 전화, 전자우편 등으로 연락되지 아니하는 경우,
                        해당 회원의 교환 또는 반품 신청은 효력을 상실합니다. ⑪
                        회사는 청약철회 등으로 인하여 결제대금을 환불하는
                        경우에는 그 청약철회 등을 한 날(단, 상품 등이 배송된
                        경우에는 판매자가 상품 등을 반환 받은 날)로부터 3영업일
                        이내에 환불에 필요한 조치를 합니다. 신용카드로 결제가
                        이루어진 경우 환불은 해당 신용카드 결제 취소를 통해서만
                        가능하고, 어떠한 경우에도 현금으로 환불되지는
                        아니합니다. ⑫ 전항에도 불구하고, 회사는 청약철회 등에
                        있어 원결제취소가 불가능하고 회원의 등록된 환불계좌가
                        없는 경우에는 이 약관 제2조 제8호에서 정의하는 “일사캐시
                        등” 중 환급이 자유로운 일사페이머니로 환불할 수
                        있습니다. 일사페이머니로 환불시 회원에게 환불금액과 동액
                        상당의 일사페이머니가 적립되고, 환불 과정에서 일사페이
                        정책과 관련 법령에 따라 회원에 대한 본인확인 등의 절차가
                        진행될 수 있습니다. 환불 등으로 인하여 회원의
                        일사페이머니가 그 한도를 초과하는 경우, 초과된 금액은
                        일사페이머니 발행 전 대기 상태로 보관할 수 있으며, 대기
                        상태로 보관되는 금액은 회원의 일사페이머니 사용시 동액
                        상당의 금액이 자동으로 일사페이머니로 발행되거나 회원이
                        일사페이에 요청하여 회원 본인의 계좌로 인출해 갈 수
                        있습니다.
                        <br />
                        <br />
                        제 31 조 (금지행위)
                        <br />
                        ① 판매자와 회원이 회사가 제공하는 서비스를 이용하지
                        아니하고 직접 거래하는 행위(직거래)는 거래의 안전을
                        위하여 금지됩니다. 이 경우 직거래를 통하여 발생한 제반
                        문제에 대한 책임은 거래 당사자들에게 있으며 회사는 이에
                        대해 어떠한 책임도 부담하지 아니 합니다. ② 제1항 이외에
                        금지되는 회원의 행위에 대하여는 이 약관 제12조의 규정에
                        따릅니다.
                        <br />
                        <br />
                        제 32 조 (분쟁조정)
                        <br />
                        ① 회사는 회원과 판매자 간 분쟁이 발생하는 경우에 이를
                        합리적이고 원활히 조정하기 위한 분쟁조정센터를
                        운영합니다. ② 회원은 분쟁조정센터의 조정에 신의칙에
                        입각하여 성실히 응하여야 합니다.
                        <br />
                        <br />
                        제 33 조 (회사의 면책)
                        <br />
                        ① 회사는 통신판매중개자로서 회원과 판매자 간의 자유로운
                        상품 등의 거래를 위한 시스템을 운영 및 관리, 제공할 뿐
                        회원 또는 판매자를 대리하지 않으며, 회원과 판매자 사이에
                        성립된 거래와 관련된 책임과 회원이 제공한 정보에 대한
                        책임은 해당 회원이 직접 부담하여야 합니다. ② 회사는
                        판매자가 등록한 상품 등의 내용과 거래조건에 대해서
                        어떠한 보증이나 대리를 하지 않으며, 회원은 본인의 위험과
                        책임 하에 상품 등을 구매해야 합니다. ③ 회사는 회원과
                        판매자 간의 모든 행위(거래행위 포함)와 관련하여 판매의사
                        또는 구매의사의 존부 및 진정성, 등록 상품의 품질,
                        완전성, 안정성, 적법성 및 타인의 권리에 대한 비침해성,
                        회원 또는 판매자가 입력하는 정보 및 그 정보를 통하여
                        연결된 웹사이트에 게재된 자료의 진실성 또는 적법성 등에
                        대하여 보증하지 아니하며, 이와 관련된 위험과 책임은 해당
                        당사자들이 부담합니다. ④ 회사는 회원 및 판매자의
                        귀책사유로 서비스 이용에 장애가 발생하는 것에 대하여
                        책임을 부담하지 아니합니다. ⑤ 회사는 회원이 본인의
                        개인정보를 타인에게 유출하거나 제공하여 발생하는 피해에
                        대하여 책임을 부담하지 아니합니다. ⑥ 회사는 천재지변,
                        컴퓨터 등 정보통신설비의 보수, 점검, 교체, 고장 및
                        통신두절 등의 사유가 발생한 경우에는 서비스 제공을
                        일시적으로 중단할 수 있으며, 이와 관련하여 고의 또는
                        과실이 없는 한 어떠한 책임도 부담하지 아니합니다. ⑦
                        회사의 고의 또는 중과실로 인한 손해에 대해서는 제1항
                        내지 제3항에 불구하고 회사가 책임을 부담합니다. 제4항 및
                        제5항의 경우에는 회사의 고의 또는 과실로 인한 손해에
                        대해 위와 같습니다.
                        <br />
                        <br />
                        제3장 기타 사항
                        <br />
                        <br />
                        제 34 조 (연결몰과 피연결몰의 관계)
                        <br />
                        ① 상위 사이버몰과 하위 사이버몰이 하이퍼링크(예 :
                        하이퍼링크의 대상에는 문자, 그림 및 동화상 등이
                        포함됨)방식 등으로 연결된 경우, 전자를 연결몰이라고
                        하고, 후자를 피연결몰이라고 합니다. ② 연결몰은
                        피연결몰이 독자적으로 제공하는 상품 등에 의하여 회원과
                        행하는 거래에 대해서 보증책임을 지지 않는다는 뜻을
                        연결몰의 초기화면 또는 연결되는 시점의 팝업화면으로
                        명시한 경우에는 그 거래에 대한 보증책임을 지지 않습니다.
                        <br />
                        <br />
                        제 35 조 (저작권의 귀속 및 이용제한)
                        <br />
                        ① 회사가 작성한 저작물에 대한 저작권 및 기타
                        지식재산권은 회사에 귀속합니다. ② 회사는 서비스와
                        관련하여 회원에게 회사가 정한 이용조건에 따라 계정,
                        아이디, 콘텐츠 등을 이용할 수 있는 이용권한만을
                        부여하며, 회원은 서비스를 이용함으로써 얻은 정보 중
                        회사에게 지식재산권이 귀속된 정보를 회사의 사전 승낙
                        없이 복제, 송신, 전송, 출판, 배포, 방송 기타 방법에
                        의하여 영리 목적으로 이용하거나 제3자에게 이용하게
                        하여서는 안됩니다.
                        <br />
                        <br />
                        제 36 조 (회원의 게시물)
                        <br />
                        ① 회원이 사이버몰에 등록 또는 게시한 게시물에 대한 모든
                        책임은 회원에게 있으며, 회사는 회원의 게시물이 다음 각
                        항에 해당한다고 인정되는 경우 사전 통지 없이 해당
                        게시물에 대한 접근을 임시적으로 차단하는 조치를 할 수
                        있고, 이 경우에 회사는 회원에게 지체없이 그 사유를
                        통지합니다. 게시물에 대한 임시 차단 조치에 대하여 회원은
                        이의를 제기할 수 있습니다. 1. 타인을 모욕, 비방,
                        비하하거나 타인의 명예를 훼손하는 게시물 2. 범죄 및 불법
                        행위에 악용될 수 있는 정보를 담고 있는 게시물 3. 타인의
                        저작권, 상표권 등 권리를 침해하는 게시물 4. 음란물 또는
                        일반인의 성적 굴욕감이나 수치심을 유발할 수 있는 내용의
                        게시물(그러한 내용이 담긴 웹사이트, 앱 등으로 연결될 수
                        있는 게시물을 포함) 5. 어린이와 청소년의 정신적, 신체적
                        건강을 해칠 우려가 있는 선정적인 내용을 담은 게시물 6.
                        특정인의 개인정보가 노출된 게시물 7. 특정 상품 등을
                        소개하여 판매하거나, 이를 구매, 사용하도록 권하거나
                        연락을 유도하는 등 직간접적으로 영리추구를 위한 내용을
                        담고 있는 게시물 8. 사이버몰의 이용 목적에 부합하지
                        않거나 해당 서비스의 취지와 무관한 내용의 게시물 9.
                        악성코드나 스파이웨어 등이 실행되어 다른 회원, 회사,
                        판매자 기타 제3자의 시스템 성능 저하, 개인정보 유출 등의
                        피해를 줄 수 있는 악의적인 코드를 담고 있는 게시물 10.
                        정당한 사유 없이 회사의 영업을 방해하는 내용의 게시물
                        11. 기타 이 약관 또는 법령에 위배되거나 공서양속에
                        반하는 내용의 게시물 ② 회원이 탈퇴하는 경우, 탈퇴 전에
                        작성한 게시물(댓글 포함)은 삭제되지 않습니다. 회원 탈퇴
                        시 회원정보가 삭제되어 작성자 본인을 확인할 수 없게
                        되므로 게시물에 대한 편집 또는 삭제가 원천적으로
                        불가하며, 게시물의 삭제를 원하는 회원은 반드시 회원 탈퇴
                        이전에 해당 게시물을 삭제하여야 합니다. ③ 회원이 작성한
                        게시물은 상품 등의 연구개발, 판촉, 홍보 등의 목적으로
                        회사가 제휴한 타사에 복제, 배포, 전송 또는 전시될 수
                        있으며, 본질적인 내용에 변경을 가하지 않는 범위 내에서
                        수정, 편집될 수 있습니다. 이 경우 회사는 해당
                        게시물로부터 회원의 개인정보가 식별되지 않도록 필요한
                        조치를 합니다.
                        <br />
                        <br />
                        제 37 조 (게시물의 관리)
                        <br />
                        ① 회원의 게시물이 『정보통신망 이용촉진 및 정보보호 등에
                        관한 법률』, 『개인정보 보호법』 및 『저작권법』등 관련
                        법령에 위반되는 내용을 포함하는 경우, 권리자는 관련
                        법령이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제
                        등을 요청할 수 있으며, 회사는 관련 법령에 따라 조치를
                        취하여야 합니다. ② 회사는 전항에 따른 권리자의 요청이
                        없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타
                        회사 정책 및 관련 법령에 위반되는 경우에는 관련 법령에
                        따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.
                        ③ 이 조에 따른 세부절차는 『정보통신망 이용촉진 및
                        정보보호 등에 관한 법률』, 『개인정보 보호법』 및
                        『저작권법』등 관련 법령이 규정한 범위 내에서 회사가
                        정한 게시중단요청서비스에 따릅니다. 게시중단요청서비스 :
                        일사 : 1566-1013
                        <br />
                        <br />
                        제 38 조 (회사의 면책)
                        <br />
                        ① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여
                        서비스를 제공할 수 없는 경우에는 서비스 제공에 관한
                        책임이 면제됩니다. ② 회사는 회원의 귀책사유로 인한
                        서비스 이용의 장애에 대하여 책임을 지지 않습니다. ③
                        회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한
                        것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여
                        얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다. ④
                        회사는 회원이 게재한 정보, 자료, 사실의 신뢰도, 정확성
                        등 내용에 관해서는 책임을 지지 않습니다. ⑤ 회사는 회원
                        간 또는 회원과 제3자 상호 간에 회사의 서비스를 매개로
                        하여 거래 등을 한 경우에는 책임이 면제됩니다. ⑥ 회사는
                        무료로 제공되는 서비스 이용과 관련하여 관련 법령에
                        특별한 규정이 없는 한 책임을 지지 않습니다. ⑦ 회사의
                        고의 또는 중과실로 인한 손해에 대해서는 제1항, 제3항
                        내지 제5항에 불구하고 회사가 책임을 부담합니다. 제2항의
                        경우에는 회사의 고의 또는 과실로 인한 손해에 대해 위와
                        같습니다.
                        <br />
                        <br />
                        제 39 조 (분쟁해결)
                        <br />
                        ① 회사는 회원이 제기하는 정당한 의견이나 불만을 반영하고
                        그 피해를 보상처리하기 위해서 피해보상처리기구를
                        설치·운영합니다. ② 회사는 회원으로부터 제출되는 불만사항
                        및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한
                        처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을
                        즉시 통보합니다.
                        <br />
                        <br />
                        제 40 조 (재판권 및 준거법)
                        <br />① 이 약관의 해석 및 회사와 회원 간의 분쟁에
                        대하여는 대한민국의 법률을 적용합니다. ② 이 약관 및
                        서비스 이용과 관련하여 회사와 회원 사이에 분쟁이
                        발생하여 소송이 제기되는 경우에는 『민사소송법』에 따라
                        관할법원을 정합니다. [ 정기주문 서비스 약관 ] 제1조
                        정기주문 서비스란? 정기주문 서비스는 고객의 편의를
                        위하여 상품을 정기적으로 배송하는 서비스로, 정기배송,
                        프레시배송 등이 이에 포함됩니다. 제2조 정기주문 서비스
                        이용 자격 정기주문 서비스는 일사(일사 주식회사, 이하
                        ‘일사’) 회원이면 누구나 정기주문 서비스를 신청함으로써
                        이용이 가능합니다. 제3조 정기주문 서비스 상품의 결제 등
                        ① 일사은 정기주문 서비스 상품에 대하여 할인 혜택을
                        제공할 수 있으며, 할인율 및 거래조건 등은 상품 별로 다를
                        수 있고 변경될 수 있습니다. 할인율 및 거래조건 등이
                        고객에게 불리하게 변경되는 경우 일사은 2주 이상의 상당한
                        기간 동안 위 변경에 대하여 공지하고, 고객은 위 변경에
                        동의하지 않으면 위 기간 동안 본 서비스를 종료시킬 수
                        있으며, 위 기간 동안 서비스를 종료시키지 않으면 위
                        변경에 고객이 동의한 것으로 봅니다. ② 정기주문 서비스의
                        특성 상 상품의 가격은 계속적으로 변경될 수 있으며,
                        고객에게 고지된 시점의 상품 가격을 기준으로 결제가
                        이루어집니다. 가격 결정의 기준 시점은 변경될 수
                        있습니다. ③ 정기주문 서비스 상품의 추가 또는 변경 시
                        결제되는 총 상품의 금액은 변경됩니다. ④ 카드 한도 초과
                        등으로 상품의 결제가 이루어 지지 않을 경우, 해당 회차의
                        정기주문은 이루어지지 않을 수 있으며, 위와 같은 상황이
                        2회 이상 지속되는 경우 일사는 정기주문 서비스를 중지할
                        수 있습니다. 제4조 정기주문 서비스 상품의 판매 종료 등
                        정기주문 대상 상품을 더 이상 판매할 수 없거나 해당
                        상품을 정기주문 서비스로 제공할 수 없는 사유가 있는
                        경우, 일사는 해당 상품의 정기주문 서비스를 중지하거나
                        해당 회차의 상품을 공급하지 않을 수 있습니다. 제5조
                        정기주문 서비스의 종료 고객은 일사에게 통지함으로써
                        정기주문 서비스를 종료시킬 수 있습니다. 제6조 정기주문
                        서비스 이용의 제한 ① 고객의 통지 또는 과실에 의해서
                        정기주문 서비스가 중지되는 경우(일부 상품에 대하여
                        정기주문 서비스가 중지되는 경우를 포함합니다.) 해당
                        상품의 정기주문 서비스 신청이 2개월의 범위 내에서 제한될
                        수 있습니다. ② 일사는 특정상품에 대하여 구매 수량을
                        제한할 수 있습니다. ③ 일사는 상품의 재판매 가능성이 있는
                        경우, 또는 불법적이거나 부당한 행위와 관련된 경우
                        정기주문 서비스 제공을 제한할 수 있습니다. ④ 서비스
                        이용의 제한에 대한 구체적인 기준은 내부 운영정책에 따라
                        적용 됩니다. ⑤ 회사는 자체적인 시스템을 통한 모니터링과
                        각종 기관에서 접수된 민원 내용, 수사기관의 정보 등을
                        통해 정황을 확인한 후, 정기주문 서비스 제한 사유 행위를
                        한 것으로 추정되는 경우 정기주문 서비스 이용을 제한 할
                        수 있습니다. 제7조 기타 ① 고객이 본 약관에 동의함으로써
                        약관의 효력이 발생하고(현재 계속 중인 정기주문
                        서비스에도 적용됩니다.), 정기주문 서비스가 계속되는 동안
                        본 약관의 효력은 유지됩니다. 고객이 정기주문 서비스
                        이용을 시작하고 정기주문 상품을 추가, 변경하는 경우에도
                        본 약관이 계속 적용됩니다. ② 정기주문 서비스의
                        개인정보보호정책은 일사 홈페이지의 개인정보취급방침을
                        준용합니다. ③ 본 약관에서 정하지 아니한 내용은 일사
                        이용약관에 따릅니다. ④ 일사가 약관을 변경하는 경우에는
                        기존약관과 개정약관 및 개정약관의 적용일자와 개정사유를
                        명시하여 현행약관과 함께 그 적용일자 7일 전부터 적용일
                        이후 상당한 기간 동안 공지만을 하고, 개정 내용이
                        고객에게 불리한 경우에는 그 적용일자 30일 전부터 적용일
                        이후 상당한 기간 동안 이를 일사 홈페이지에 공지하고
                        고객의 이메일 주소로 약관 개정 사실을 발송하여
                        고지합니다. ⑤ 일사가 전항에 따라 고객에게 통지하면서
                        공지 또는 공지∙고지일로부터 개정약관 시행일 7일 후까지
                        거부의사를 표시하지 아니하면 이를 승인한 것으로 본다는
                        뜻을 명확하게 고지하였음에도 불구하고 거부의 의사표시가
                        없는 경우에는 변경된 약관을 승인한 것으로 봅니다. 고객이
                        개정약관에 동의하지 않을 경우 고객은 제5조에 따라
                        정기주문 서비스를 종료시킬 수 있습니다. ⑥ 회사가
                        영업양도 등의 방법으로 이 약관의 내용 중 일사페이를
                        이용한 업무의 처리 및 전자금융거래이용약관에 따른
                        계약관계(관련 권리 및 의무 포함)를 관련 법률에서 정한
                        절차에 따라 포괄적으로 이전하고자 하는 경우, 그 사실을
                        회원에게 공지 및 개별적으로 통지하고 회원이 이에 대하여
                        30일간 동의 또는 승낙을 거부하는 의사표시를 하지
                        아니하는 경우 이에 대하여 동의 또는 승낙한 것으로
                        봅니다. 회원이 본 항에 동의하지 않는 경우 또는 본 항에
                        따른 동의 또는 승낙을 거부하는 경우 언제라도 이 약관 및
                        회사의 전자금융거래이용약관에 따른 서비스 이용계약을
                        해지할 수 있습니다.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() => setModalOpen(false)}
                      className="self-center mt-5 w-[79px] text-white bg-teal-500 py-2 rounded-[18px] text-sm font-extraBold"
                    >
                      확인
                    </button>
                  </div>
                </div>
              </div>
            )}

            {currentModal === "ag3" && (
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[320px] w-full">
                <div className="bg-white py-5">
                  <div className="mt-3 text-left flex flex-col">
                    <div className="flex justify-between px-5">
                      <h3
                        className="text-base leading-6 font-extrabold"
                        id="modal-title"
                      >
                        전자금융거래 이용약관 동의
                      </h3>
                      <button type="button" onClick={() => setModalOpen(false)}>
                        <img src="./assets/close.svg" />
                      </button>
                    </div>
                    <div className="border-b border-gray-300 my-5"></div>
                    <div className="mt-2 px-5 h-[320px] overflow-y-auto">
                      <p className="text-[12px]">
                        일사 파트너스 전자금융거래이용약관
                        <br />
                        <br />
                        제 1장. 총칙
                        <br />
                        제1조(목적)
                        <br />
                        본 약관은 넷스프린트 주식회사(이하 “회사”라 합니다)가
                        제공하는 전자지급결제대행서비스 및 결제대금예치서비스,
                        선불전자지급수단 발행 및 관리 서비스(이하 통칭하여
                        “전자금융거래서비스”라 합니다)를 이용자가 이용함에 있어
                        회사와 이용자 사이의 전자금융거래에 관한 기본적인 사항을
                        정함을 목적으로 합니다.
                        <br />
                        <br />
                        제2조 (용어의 정의)
                        <br />
                        본 약관에서 정하는 용어의 정의는 다음과 같으며, 본 조 및
                        본 약관에서 별도로 정의하지 아니한 용어의 정의는
                        「전자금융거래법」 등 관련법령이 정한 바에 의합니다. 1.
                        “전자금융거래”라 함은 회사가 전자적 장치를 통하여
                        전자금융거래서비스를 제공하고, 이용자가 회사의 종사자와
                        직접 대면하거나 의사소통을 하지 아니하고 자동화된
                        방식으로 이를 이용하는 거래를 말합니다. 2.
                        “전자지급거래”라 함은 자금을 주는 자(이하 “지급인”이라고
                        합니다)가 회사로 하여금 전자지급수단을 이용하여 자금을
                        받는 자(이하 “수취인”이라고 합니다)에게 자금을 이동하게
                        하는 전자금융거래를 말합니다. 3. “전자지급수단”이라 함은
                        선불전자지급수단, 신용카드 등 「전자금융거래법」 제2조
                        제11호에서 정하는 전자적 방법에 따른 지급수단을
                        말합니다. 4. “전자적 장치”라 함은 전자금융거래정보를
                        전자적 방법으로 전송하거나 처리하는데 이용되는 장치로서
                        현금자동지급기, 자동입출금기, 지급용 단말기, 컴퓨터,
                        전화기 그 밖에 전자적 방법으로 정보를 전송하거나
                        처리하는 장치를 말합니다. 5. “전자문서"라 함은
                        「전자문서 및 전자거래 기본법」 제2조제1호에 따른
                        정보처리시스템에 의하여 전자적 형태로 작성, 송신ㆍ수신
                        또는 저장된 정보를 말합니다. 6. "이용자"라 함은 이
                        약관에 동의하고 회사가 제공하는 전자금융거래서비스를
                        이용하는 자를 말합니다. 7. “이용자번호”라 함은 이용자의
                        동일성 식별과 서비스 이용을 위하여, 이용자가 설정하고
                        회사가 승인한 숫자와 문자의 조합을 말합니다. 8.
                        “비밀번호”라 함은 이용자의 동일성 식별과 이용자 정보의
                        보호를 위하여, 이용자가 설정하고 회사가 승인한 숫자와
                        문자의 조합을 말합니다 9. "접근매체"라 함은
                        전자금융거래에 있어서 거래지시를 하거나 이용자 및
                        거래내용의 진실성과 정확성을 확보하기 위하여 사용되는
                        수단 또는 정보로서 전자식 카드 및 이에 준하는 전자적
                        정보(신용카드번호를 포함한다), 「전자서명법」 상의
                        인증서, 회사에 등록된 이용자번호, 이용자의 생체정보,
                        이상의 수단이나 정보를 사용하는데 필요한 비밀번호 등
                        전자금융거래법 제2조 제10호에서 정하고 있는 것을
                        말합니다. 10. "거래지시"라 함은 이용자가 본 약관에
                        의하여 체결되는 전자금융거래계약에 따라 회사에 대하여
                        전자금융거래의 처리를 지시하는 것을 말합니다. 11.
                        "오류"라 함은 이용자의 고의 또는 과실 없이
                        전자금융거래가 전자금융거래계약 또는 이용자의 거래지시에
                        따라 이행되지 아니한 경우를 말합니다.
                        <br />
                        <br />
                        제3조 (약관의 명시 및 변경)
                        <br />
                        ① 회사는 이용자가 전자금융거래 서비스를 이용하기 전에 본
                        약관을 서비스 페이지에 게시하고 이용자가 본 약관의
                        중요한 내용을 확인할 수 있도록 합니다. ② 회사는 이용자의
                        요청이 있는 경우 전자문서의 전송(전자우편을 이용한
                        전송을 포함합니다) 방식으로 본 약관의 사본을 이용자에게
                        교부합니다. ③ 회사가 약관을 변경하는 때에는 그 시행일
                        1월 전에 변경되는 약관을 회사가 제공하는 전자금융거래
                        서비스 이용 초기화면 및 회사의 홈페이지에 게시함으로써
                        이용자에게 공지합니다. 다만, 법령의 개정으로 인하여
                        긴급하게 약관을 변경한 때에는 변경된 약관을 서비스 이용
                        초기화면 또는 홈페이지(WWW.COUPANG.COM)에 1개월 이상
                        게시하고 이용자에게 전자우편 등을 통하여 사후
                        통지합니다. ④ 회사는 제3항의 공지 또는 통지를 할 경우
                        “이용자가 변경에 동의하지 아니한 경우 공지나 통지를 받은
                        날로부터 30일 이내에 계약을 해지할 수 있으며, 계약해지의
                        의사표시를 하지 아니한 경우에는 변경에 동의한 것으로
                        본다“라는 취지의 내용을 고지하거나 통지합니다. ⑤
                        이용자가 제4항에 따른 고지나 통지를 받은 날로부터 30일
                        이내에 계약해지의 의사표시를 하지 아니한 경우에는 변경에
                        동의한 것으로 봅니다.
                        <br />
                        <br />
                        제4조 (전자금융거래서비스의 구성 및 내용)
                        <br />
                        ① 전자금융거래서비스는 다음 각 호의 서비스로 구성되며,
                        필요한 경우에는 본 약관의 각 장에서 해당 서비스에 대한
                        자세한 내용을 게시합니다. 1. 전자지급결제대행서비스 2.
                        결제대금예치서비스 3. 선불전자지급수단의 발행 및 관리
                        서비스 ② 회사는 전자금융거래서비스를 추가하거나
                        변경하고자 하는 경우에는 이용자에게 그 내용을 사전
                        고지하고 해당 전자금융거래서비스를 추가하거나 변경할 수
                        있습니다.
                        <br />
                        <br />
                        제5조 (추심이체의 동의 및 철회)
                        <br />
                        ① 이용자가 추심이체의 동의를 함에 있어서는 회사가
                        제공하는 방식과 요건에 따른 전자서면으로 동의를
                        제공하여야 합니다. ② 회사는 전자금융감독규정에서 정한
                        요건에 부합하는 방식과 요건의 전자서면을 통한 동의
                        방식을 제공하며, 추심이체의 실행을 위하여 이용자로부터
                        수령한 동의 사항을 금융결제원 및 해당 금융기관 등에게
                        제출합니다. ③ 이용자는 회사의 거래지시에 따라 이용자의
                        계좌 원장에 출금기록이 기입되기 전까지 회사에 대하여
                        전항의 규정에 따른 동의의 철회를 요청할 수 있습니다.
                        이용자는 일사페이 서비스 화면을 통하여 회사에 등록된
                        계좌를 말소하는 방법으로 출금이체 동의를 철회할 수
                        있습니다. 다만, 이용자는 동의 철회의 의사표시 이전에
                        발생한 출금건에 대하여 이의를 제기할 수 없습니다 ④
                        회사는 대량으로 처리되는 거래 또는 예약에 따른 거래 등의
                        경우에는 미리 이용자와 정한 약정에 따라 동의의
                        철회시기를 달리 정할 수 있습니다.
                        <br />
                        <br />
                        제6조 (이용 시간)
                        <br />
                        ① 회사는 이용자에게 연중무휴 1일 24시간 전자금융거래
                        서비스를 제공함을 원칙으로 합니다. 단, 금융기관 기타
                        결제수단 발행업자의 사정에 따라 달리 정할 수 있습니다. ②
                        회사는 정보통신설비의 보수, 점검 기타 기술상의 필요나
                        금융기관 기타 결제수단 발행업자의 사정에 의하여
                        전자금융거래서비스 중단이 불가피한 경우, 서비스 중단 3일
                        전까지 게시 가능한 전자적 수단을 통하여 서비스 중단
                        사실을 게시한 후 서비스를 일시 중단할 수 있습니다. 다만,
                        시스템 장애복구, 긴급한 프로그램 보수, 외부요인 등
                        불가피한 경우에는 사전 게시 없이 서비스를 중단할 수
                        있습니다.
                        <br />
                        <br />
                        제7조 (접근매체의 선정과 사용 및 관리)
                        <br />
                        ① 회사는 전자금융거래서비스 제공 시 접근매체를 선정하여
                        이용자의 신원, 권한 및 거래지시의 내용 등을 확인합니다.
                        ② 이용자는 접근매체를 제3자에게 대여하거나 사용을
                        위임하거나 양도 또는 담보 목적으로 제공할 수 없으며,
                        이러한 행위를 알선하여서는 안됩니다. ③ 이용자는 자신의
                        접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는
                        안되며, 접근매체의 도용이나 위조 또는 변조를 방지하기
                        위하여 충분한 주의를 기울여야 합니다. ④ 회사는
                        이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은
                        때에는 그 때부터 제3자가 그 접근매체를 사용함으로 인하여
                        이용자에게 발생한 손해를 배상할 책임이 있습니다.
                        <br />
                        <br />
                        제8조 (거래내용의 확인)
                        <br />
                        ① 회사는 서비스 내 이용자 정보 조회 화면을 통하여
                        이용자가 자신의 거래내용(이용자의 '오류정정 요구사실 및
                        처리결과에 관한 사항'을 포함합니다)을 확인할 수 있도록
                        하며, 이용자가 거래내용에 대하여 서면 교부를 요청하는
                        경우에는 요청을 받은 날로부터 2주 이내에 모사전송 등의
                        방법으로 거래내용에 관한 서면을 교부합니다. 다만, 전자적
                        장치의 운영 장애, 그 밖의 사유로 거래내용을 제공할 수
                        없는 때에는 즉시 이용자에게 전자문서 전송(전자우편을
                        이용한 전송을 포함합니다)의 방법으로 그러한 사유를
                        알려야 하며, 전자적 장치의 운영장애 등의 사유로
                        거래내용을 제공할 수 없는 기간은 서면교부 기간에
                        산입하지 아니합니다. ② 제1항의 대상이 되는 거래 내용 중
                        대상기간이 5년인 것은 다음 각 호와 같습니다. 1.
                        거래계좌의 명칭 또는 번호 2. 전자금융거래의 종류 및 금액
                        3. 전자금융거래상대방을 나타내는 정보 4.
                        전자금융거래일시 5. 전자적 장치의 종류 및 전자적 장치를
                        식별할 수 있는 정보 6. 회사가 전자금융거래의 대가로 받은
                        수수료 7. 이용자의 출금 동의에 관한 사항 8. 해당
                        전자금융거래와 관련한 전자적 장치의 접속기록 9.
                        전자금융거래의 신청 및 조건의 변경에 관한 사항 10. 건당
                        거래금액이 1만원을 초과하는 전자금융거래에 관한 기록 ③
                        제1항의 대상이 되는 거래내용 중 대상기간이 1년인 것은
                        다음 각호와 같습니다. 1. 전자지급수단 이용과 관련된
                        거래승인에 관한 기록 2. 이용자의 오류정정 요구사실 및
                        처리결과에 관한 사항 3. 기타 금융위원회가 고시로 정한
                        사항 4. 건당 거래금액이 1만원 이하인 소액 전자금융거래에
                        관한 기록 ④ 이용자가 제1항에서 정한 서면교부를
                        요청하고자 할 경우 다음의 주소 및 전화번호로 요청할 수
                        있습니다. * 주소 : 서울시 중구 청계천로 100 시그니쳐타워
                        926호 * 이메일 주소 : customer@ilsaram.co.kr * 전화번호
                        : 1566-1013
                        <br />
                        <br />
                        제9조 (오류의 정정 등)
                        <br />
                        ① 이용자는 전자금융거래 서비스를 이용함에 있어 오류가
                        있음을 안 때에는 회사에 대하여 그 정정을 요구할 수
                        있습니다. ② 회사는 전항의 규정에 따른 오류의 정정요구를
                        받은 때 또는 스스로 오류가 있음을 안 때에는 이를 즉시
                        조사하여 처리한 후 정정요구를 받은 날 또는 오류가 있음을
                        안 날부터 2주 이내에 그 결과를 이용자에게 문서로
                        알립니다. 다만, 이용자의 주소가 분명하지 아니하거나
                        이용자가 요청한 경우에는 전화 또는 전자우편 등의
                        방법으로 알릴 수 있습니다.
                        <br />
                        <br />
                        제10조 (회사의 책임)
                        <br />
                        ① 회사는 다음 각 호의 어느 하나에 해당하는 사고로 인하여
                        이용자에게 손해가 발생한 경우에는 그 손해를 배상할
                        책임을 부담합니다. 1. 접근매체의 위조나 변조로 발생한
                        사고 2. 계약체결 또는 거래지시의 전자적 전송이나
                        처리과정에서 발행한 사고 3. 전자금융거래를 위한 전자적
                        장치 또는 「정보통신망 이용촉진 및 정보보호 등에 관한
                        법률」 제2조제1항제1호에 따른 정보통신망에 침입하여
                        거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의
                        이용으로 발생한 사고 ② 회사는 제1항에도 불구하고 다음 각
                        호의 어느 하나에 해당하는 사유로 인하여 이용자에게
                        발생한 손해의 전부 또는 일부를 그 이용자가 부담하게 할
                        수 있습니다. 1. 이용자가 접근매체를 제3자에게 대여하거나
                        그 사용을 위임한 경우 또는 양도나 담보의 목적으로 제공한
                        경우 2. 제3자가 권한 없이 이용자의 접근매체를 이용하여
                        전자금융거래를 할 수 있음을 알았거나 쉽게 알 수
                        있었음에도 불구하고 접근매체를 누설하거나 노출 또는
                        방치한 경우 3. 금융회사 또는 전자금융업자가
                        「전자금융거래법」 제6조제1항에 따른 확인 외에
                        보안강화를 위하여 전자금융거래 시 요구하는 추가적인
                        보안조치를 이용자가 정당한 사유 없이 거부하여 전항
                        제3호에 따른 사고가 발생한 경우 4. 이용자가 제3호에 따른
                        추가적인 보안조치에 사용되는 매체ㆍ수단 또는 정보에
                        대하여 누설ㆍ노출 또는 방치하거나 이를 제3자에게
                        대여ㆍ사용위임ㆍ양도 또는 담보의 목적으로 제공하여 전항
                        제3호에 따른 사고가 발생한 경우 5.
                        법인(「중소기업기본법」 제2조제2항에 따른 소기업을
                        제외합니다)인 이용자에게 손해가 발생한 경우로서 회사가
                        사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히
                        준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한
                        경우 ③ 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체의
                        사유 등이 발생한 경우에는 전자금융거래서비스의 제공을
                        일시적으로 중단할 수 있습니다. 이 경우 회사는
                        인터넷사이트 등을 통하여 이용자에게 전자금융거래서비스
                        제공의 중단일정 및 중단사유를 사전에 공지합니다.
                        <br />
                        <br />
                        제11조 (거래지시의 철회)
                        <br />
                        ① 이용자는 회사의 전자금융거래서비스를 이용하여
                        전자지급거래를 한 경우 지급의 효력이 발생하기 전까지 본
                        약관에서 정한 바에 따라 제8조 제4항에 기재된 연락처로
                        전자문서의 전송(전자우편을 이용한 전송을 포함합니다)
                        또는 서비스 페이지 내 철회에 의한 방법으로 거래지시를
                        철회할 수 있습니다. 단, 각 서비스 별 거래지시 철회의
                        효력 발생시기는 본 약관 제18조, 제22조 및 제27조에서
                        정한 바에 따릅니다. ② 이용자는 전자지급의 효력이 발생한
                        경우에 「전자상거래 등에서의 소비자보호에 관한 법률」 등
                        관련 법령상 청약의 철회 방법에 따라 결제대금을 반환 받을
                        수 있습니다.
                        <br />
                        <br />
                        제12조 (전자금융거래 기록의 생성 및 보존)
                        <br />
                        ① 회사는 이용자가 이용한 전자금융거래의 내용을 추적,
                        검색하거나 그 내용에 오류가 발생한 경우에 이를
                        확인하거나 정정할 수 있는 기록을 생성하여 보존합니다. ②
                        전항의 규정에 따라 회사가 보존하여야 하는 기록의 종류 및
                        보존방법은 제8조 제2항 및 3항에서 정한 바에 따릅니다.
                        <br />
                        <br />
                        제13조 (전자금융거래정보의 제공금지)
                        <br />
                        ① 회사는 전자금융거래서비스를 제공함에 있어서 취득한
                        이용자의 인적사항, 이용자의 계좌, 접근매체 및
                        전자금융거래의 내용과 실적에 관한 정보 또는 자료를
                        법령에 의하거나 이용자의 동의를 얻지 아니하고 제3자에게
                        제공, 누설하거나 업무상 목적 외에 사용하지 아니합니다. ②
                        회사는 이용자가 안전하게 전자금융거래서비스를 이용할 수
                        있도록 이용자의 개인정보보호를 위하여 개인정보취급방침을
                        운용합니다. 회사의 개인정보취급방침은 회사의 홈페이지
                        또는 서비스 페이지에 링크된 화면에서 확인할 수 있습니다.
                        <br />
                        <br />
                        제14조 (분쟁처리 및 분쟁조정)
                        <br />
                        ① 이용자는 회사의 서비스 페이지 하단에 게시된 분쟁처리
                        담당자에 대하여 전자금융거래 서비스 이용과 관련한 의견
                        및 불만의 제기, 손해배상의 청구 등의 분쟁처리를 요구할
                        수 있습니다. ② 회사는 이용자가 회사에 대하여 분쟁처리를
                        신청한 날로부터 15일 이내에 이에 대한 조사 또는 처리
                        결과를 이용자에게 안내합니다. ③ 이용자는 제2항에 따른
                        회사의 분쟁처리결과에 대하여 이의가 있을 경우에는
                        「금융위원회의 설치 등에 관한 법률」에 따른 금융감독원의
                        금융분쟁조정위원회나 「소비자기본법」에 따른
                        한국소비자원에 회사의 전자금융거래서비스의 이용과 관련한
                        분쟁조정을 신청할 수 있습니다.
                        <br />
                        <br />
                        제15조 (회사의 안전성 확보 의무)
                        <br />
                        회사는 전자금융거래가 안전하게 처리될 수 있도록 선량한
                        관리자로서 주의를 다하며, 전자금융거래의 안전성과
                        신뢰성을 확보할 수 있도록 전자금융거래의 종류별로 전자적
                        전송이나 처리를 위한 인력, 시설, 전자적 장치 등의
                        정보기술부문 및 전자금융업무에 관하여 금융위원회가
                        정하는 기준을 준수합니다.
                        <br />
                        <br />
                        제16조 (약관 외 준칙 및 관할)
                        <br />
                        ① 회사와 이용자 사이에 개별적으로 합의한 사항이 이
                        약관에 정한 사항과 다를 때에는 그 합의사항을 이 약관에
                        우선하여 적용합니다. ② 이 약관에서 정하지 아니한 사항에
                        대하여는 「전자금융거래법」, 「전자상거래 등에서의
                        소비자 보호에 관한 법률」, 「여신전문금융업법」 등
                        소비자보호 관련 법령에서 정한 바에 따릅니다. ③ 회사와
                        이용자 간에 발생한 분쟁에 관한 관할은 「민사소송법」에서
                        정한 바에 따릅니다.
                        <br />
                        <br />
                        제2장 전자지급결제대행 서비스
                        <br />
                        <br />
                        제17조 (정의)
                        <br />
                        "전자지급결제대행 서비스"라 함은 전자적 방법으로 재화
                        또는 용역(이하 이 약관에서 "재화 등"이라고 합니다)의
                        구매에 있어서 지급결제 정보를 송신하거나 수신하는 것
                        또는 그 대가의 정산을 대행하거나 매개하는 서비스를
                        말합니다.
                        <br />
                        <br />
                        제18조 (거래지시의 철회)
                        <br />
                        ① 이용자가 전자지급결제대행 서비스를 이용한 경우,
                        이용자가 선불전자지급수단으로 지급하는 경우 거래지시된
                        금액의 정보가 수취인이 지정한 전자적 장치에 도달하기
                        전까지, 그 밖의 전자지급수단으로 지급하는 경우
                        거래지시된 금액의 정보가 수취인의 계좌가 개설되어 있는
                        금융회사 또는 회사의 전자적 장치에 입력이 끝나기 전까지
                        거래지시를 철회할 수 있습니다. ② 회사는 이용자의
                        거래지시의 철회에 따라 지급거래가 이루어지지 않은 경우
                        수령한 자금을 이용자에게 반환하여야 합니다.
                        <br />
                        <br />
                        제19조 (한도 등)
                        <br />
                        회사의 정책 및 결제업체(이동통신사, 카드사 등)의 기준에
                        따라 이용자의 결제수단별 월 누적 결제액 및 결제한도가
                        제한될 수 있으며, 관련 내용은 고객센터 페이지에서 확인할
                        수 있습니다.
                        <br />
                        <br />
                        제3장 결제대금예치서비스
                        <br />
                        <br />
                        제20조 (정의)
                        <br />
                        본 장에서 정하는 용어의 정의는 다음과 같습니다. 1.
                        “결제대금예치서비스”라 함은 인터넷사이트 등에서
                        이루어지는 선지급식 통신판매에 있어서, 회사는 소비자가
                        지급하는 결제대금을 예치하고 배송이 완료된 후 재화 등의
                        대금을 판매자에게 지급하는 제도를 말합니다. 2. “선지급식
                        통신판매”라 함은 소비자가 재화 등을 공급받기 전에 미리
                        대금의 전부 또는 일부를 지급하는 대금 지급 방식의
                        통신판매를 말합니다. 3. “판매자”라 함은 본 약관에
                        동의하고 인터넷사이트 등에 입점한 자로서, 통신판매를
                        하는 자를 말합니다. 4. “소비자”라 함은 본 약관에
                        동의하고 인터넷사이트 등에 입점한 판매자로부터 재화 등을
                        구매하는 자로서 「전자상거래 등에서의 소비자보호에 관한
                        법률」 제2조제5호의 요건에 해당하는 자를 말합니다.
                        <br />
                        <br />
                        제21조 (결제대금예치서비스의 내용 및 지급방법)
                        <br />
                        ① 소비자(소비자의 동의가 있는 경우에는 재화 또는 용역을
                        공급받을 자를 포함합니다)는 재화 또는 용역을 공급받은
                        사실을 재화 또는 용역을 공급받은 날부터 3영업일 이내에
                        회사에 통보하여야 합니다. ② 회사는 소비자로부터 재화
                        또는 용역을 공급받은 사실을 통보받은 후 회사와
                        통신판매업자간 사이에서 정한 기일 내에 판매자에게
                        결제대금을 지급합니다. ③ 회사는 소비자가 재화 또는
                        용역을 공급받은 날부터 3영업일이 지나도록 정당한 사유의
                        제시 없이 그 공급받은 사실을 회사에 통보하지 아니하는
                        경우에는 소비자의 동의 없이 판매자에게 결제대금을 지급할
                        수 있습니다. ④ 회사는 판매자에게 결제대금을 지급하기
                        전에 소비자에게 결제대금을 환급할 사유가 발생한 경우에는
                        그 결제대금을 소비자에게 환급합니다.
                        <br />
                        <br />
                        제22조 (거래지시의 철회)
                        <br />
                        ① 이용자가 결제대금예치서비스를 이용한 경우, 이용자가
                        선불전자지급수단으로 지급하는 경우 거래지시된 금액의
                        정보가 수취인이 지정한 전자적 장치에 도달하기 전까지, 그
                        밖의 전자지급수단으로 지급하는 경우 거래지시된 금액의
                        정보가 수취인의 계좌가 개설되어 있는 금융회사 또는
                        회사의 전자적 장치에 입력이 끝나기 전까지 거래지시를
                        철회할 수 있습니다. ② 회사는 이용자의 거래지시의 철회에
                        따라 지급거래가 이루어지지 않은 경우 수령한 자금을
                        이용자에게 반환하여야 합니다.
                        <br />
                        <br />
                        제4장 선불전자지급수단의 발행 및 관리
                        <br />
                        <br />
                        제23조 (정의)
                        <br />
                        본 장에서 사용하는 용어의 정의는 다음과 같습니다. 1.
                        ‘선불전자지급수단’이라 함은 인터넷사이트 등에서 이용되는
                        일사캐시 등 회사가 발행 당시 미리 이용자에게 공지한
                        전자금융거래법상 선불전자지급수단을 말합니다. 회사가
                        발행한 각종 선불전자지급수단의 상세 내용은 인터넷사이트
                        등의 해당 서비스 화면을 통하여 확인할 수 있습니다. 2.
                        ‘충전’이라 함은 선불전자지급수단의 일정액을 확보하기
                        위해 회사가 지정한 지불수단을 통해 선불전자지급수단을
                        유상으로 구매하여 보유하는 것을 말합니다. 3. ‘판매자’라
                        함은 선불전자지급수단에 의한 거래에 있어서 이용자에게
                        재화 등을 판매하는 자를 말합니다. 4. ‘선불충전금’이란
                        이용자가 선불전자지급수단 발행의 대가로 회사에 지급한
                        금액으로서 유상으로 구매하여 충전한 선불전자지급수단의
                        잔액을 말합니다.
                        <br />
                        <br />
                        제24조 (선불전자지급수단 사용제한)
                        <br />
                        ① 회사는 이용자가 아래 각 호의 사유에 해당하는 경우 해당
                        이용자에게 전자우편 또는 기타 유효한 수단을 통해
                        통보하고, 이용자의 선불전자지급수단의 사용을 일시적으로
                        제한할 수 있습니다. 1. 등록한 개인정보의 전부 또는
                        일부가 허위임이 밝혀지는 경우 2. 타인의 명의나
                        개인정보를 도용하여 가입 후 선불전자지급수단을 이용하는
                        경우 3. 타인의 결제정보 등을 도용하거나 부정한 행위로
                        거래를 하는 경우 4. 이용자의 접근매체를 매매하거나
                        양도하는 경우 5. 다른 이용자의 선불전자지급수단 사용을
                        방해하거나, 회사의 선불전자지급수단 제공에 지장을
                        초래하는 경우 6. 회사가 정한 기간 내에 사용제한 사유를
                        해소하지 못한 경우 ② 제1항에 해당하는 이용자는 해당
                        사유를 해소한 이후 회사의 승낙에 따라 선불전자지급수단을
                        다시 사용할 수 있습니다.
                        <br />
                        <br />
                        제25조 (선불전자지급수단의 충전 및 적립)
                        <br />
                        ① 이용자는 계좌출금, 휴대폰, 신용카드, 무통장입금, 기타
                        회사가 정하는 지불수단으로 선불전자지급수단을 구매하여
                        충전하거나, 서비스 등에서의 활동으로 회사 또는 회사의
                        제휴사로부터 적립, 제공받을 수 있습니다. ② 회사가 지정한
                        지불 수단을 통한 선불전자지급수단 구매는 제1항에서
                        규정하는 지불 수단별로 지정된 금액으로 충전을 할 수
                        있으며, 지불 수단에 따라 자체 제한금액이 있을 수
                        있습니다. ③ 이용자는 본 조에 따른 지불 수단별 충전 및
                        적립 정책을 고객센터 페이지에서 확인할 수 있습니다.
                        <br />
                        <br />
                        제26조 (선불전자지급수단 이용 및 차감)
                        <br />
                        ① 이용자는 회사가 정한 기한 및 이용방법에 따라
                        선불전자지급수단을 이용할 수 있으며, 회사는 그 구체적인
                        사항을 본 약관 또는 선불전자지급수단 관련 서비스
                        페이지를 통해 공지합니다. ② 이용자는 서비스 등에서 재화
                        등을 구매할 때 선불전자지급수단을 지불수단으로 사용할 수
                        있습니다. ③ 선불전자지급수단은 재화 등의 구매완료 시점에
                        즉시 차감됩니다. ④ 이용자가 선불전자지급수단을 사용하는
                        경우 서비스 등에서 적립 받은 무상의 선불전자지급수단,
                        이용자가 구매한 선불전자지급수단의 순서로 차감합니다. ⑤
                        이용자가 선불전자지급수단을 사용한 재화 등의 구매를
                        취소하는 경우 회사는 재화 등 구매 시 사용한
                        선불전자지급수단을 재충전 또는 재적립하는 것을 원칙으로
                        합니다.
                        <br />
                        <br />
                        제27조 (거래지시의 철회)
                        <br />
                        이용자가 선불전자지급수단을 이용하여 자금을 지급하는
                        경우, 이용자는 거래 지시된 금액의 정보가 수취인이 지정한
                        전자적 장치에 도달하기 전까지 거래지시를 철회할 수
                        있습니다.
                        <br />
                        <br />
                        제28조 (선불전자지급수단의 소멸)
                        <br />
                        ① 유상으로 발행된 선불전자지급수단 및 제휴사의 포인트가
                        전환된 선불전자지급수단의 소멸시효는 마지막 적립,
                        충전일, 전환일 또는 사용일로부터 5년이며, 이용자는
                        회사가 정한 소멸시효 내에서만 선불전자지급수단을 사용할
                        수 있습니다. ② 무상으로 제공되는 선불전자지급수단의
                        유효기간은 해당 이벤트 등에 따라 결정됩니다. 회사는 해당
                        이벤트 등에 관한 서비스 페이지 또는 고객센터 페이지 등을
                        통하여 유효기간 설정 여부 및 그 기간을 사전에
                        고지합니다. ③ 본 약관에 대한 동의를 철회(회원 탈퇴)하는
                        경우 무상으로 제공되는 선불전자지급수단은 소멸되어
                        환급이 불가능합니다.
                        <br />
                        <br />
                        제29조 (구매취소 및 환급 등)
                        <br />
                        ① 구매한 선불전자지급수단은 구매일로부터 7일 이내인 경우
                        구매 취소가 가능합니다. ② 이용자는 보유 중인
                        선불전자지급수단의 환급을 회사에 요구할 경우, 다음 각
                        호에 따라 충전 또는 적립, 제공된 선불전자지급수단을
                        환급받을 수 있습니다. 1. 유상으로 충전한
                        선불전자지급수단의 경우에는 미상환 잔액에 대하여 전액
                        환급합니다. 단, 회사 또는 제휴사의 기프트카드 등을
                        구매하여 충전한 선불전자지급수단의 경우에는 마지막
                        충전시점 총 잔액의 60% 이상(1만원 이하는 80%이상)을
                        사용한 경우에 그 잔액을 환급합니다. 2. 상품 구매나
                        이벤트 등을 통하여 회사로부터 무상으로 제공받거나 전환된
                        선불전자지급수단 : 환급 대상에서 제외(무상 제공 시에
                        해당 선불전자지급수단의 환급이 가능함을 이용자에게
                        사전에 공지하거나 통지한 경우에는 환급) ③ 제2항에도
                        불구하고, 천재지변 등의 사유로 가맹점이 재화 또는 용역을
                        제공하기 곤란하여 선불전자지급수단을 사용하지 못하게 된
                        경우 또는 선불전자지급수단의 결함으로 가맹점이 재화 또는
                        용역을 제공하지 못하는 경우에는 선불전자지급수단에
                        기록된 잔액의 전부를 지급합니다. ④ 이용자는 회사에서
                        정한 기한 및 이용방법에 따라 선불전자지급수단을 이용할
                        수 있으며, 회사는 환급 등 구체적인 사항을 개별
                        선불전자지급수단의 고객센터 페이지를 통해 안내합니다.
                        <br />
                        <br />
                        제30조 (선불전자지급수단의 한도 등)
                        <br />
                        ① 회사는 선불전자지급수단에 대해 실지명의 당 최고
                        200만원을 그 보유 한도로 하고, 실지명의가 확인되지 않은
                        경우 50만원을 보유한도로 합니다. 단 보유 한도는 회사의
                        정책에 따라 감액될 수 있습니다. ② 회사의 정책 및
                        결제업체(이동통신사, 카드사 등)의 기준에 따라 이용자의
                        결제수단 별 월 누적 결제액 및 결제한도가 제한될 수
                        있습니다. ③ 이용자는 본 조에 따른 회사의 정책을 고객센터
                        페이지에서 확인할 수 있습니다.
                        <br />
                        <br />
                        제31조 (선불충전금의 관리 및 관련 공시)
                        <br />
                        ① 회사는 이용자의 선불충전금을 고유재산과 구분하여 외부
                        금융기관에 신탁하거나 지급보증보험에 가입하여야 합니다.
                        ② 회사는 매 영업일 마다 선불충전금 총액과 신탁금 등 실제
                        운용중인 자금 총액의 상호 일치 여부를 점검하여야 하며,
                        매 분기말(분기 종료 후 10일 이내) 선불충전금 규모 및
                        신탁내역, 지급보증보험 가입여부, 부보 금액 등을
                        홈페이지(WWW.COUPANG.COM) 등에 공시하여야 합니다. ③
                        회사는 다음 각 호의 어느 하나에 해당하는 경우
                        선불충전금을 신탁회사 및 보험회사 등을 통하여 이용자에게
                        우선 지급하여야 합니다. 이 경우 1개월 이내에 그 사실과
                        선불충전금의 지급시기, 지급장소, 그 밖에 선불충전금의
                        지급과 관련된 사항을 둘 이상의 일간신문에 공고하고,
                        인터넷 홈페이지 등을 통하여 공시하여야 합니다. 1. 등록이
                        취소되거나 말소된 경우 2. 해산 또는 선불전자지급수단
                        발행 및 관리 업무를 폐지한 경우 3. 파산선고를 받은 경우
                        4. 선불전자지급수단 발행 및 관리 업무의 정지명령을 받은
                        경우 5. 제1호부터 제4호까지에 준하는 사유가 발생한 경우
                        제32조 (선불충전금의 신탁 또는 지급보증보험) ① 회사는
                        선불충전금의 50% 이상을 이용자를 수익자로 하여
                        신탁하거나 이용자를 피보험자로 하여 지급보증보험에
                        가입하여야 합니다. ② 회사는 선불충전금을 원칙적으로
                        신탁하되, 불가피한 경우 지급보증의 방식을 혼합할 수
                        있습니다. ③ 회사가 선불충전금을 신탁하는 경우 대상금액을
                        전액 신탁하여야 하며, 일부를 지급준비금 용도로 예치할 수
                        없습니다. ④ 회사는 신탁 또는 지급보증보험에 가입하지
                        않은 나머지 선불충전금을 운용하는 경우 안전자산으로
                        운용하여야 합니다.
                        <br />
                        <br />
                        부칙 이 약관은 2024년 09월 28일부터 시행됩니다.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() => setModalOpen(false)}
                      className="self-center mt-5 w-[79px] text-white bg-teal-500 py-2 rounded-[18px] text-sm font-extraBold"
                    >
                      확인
                    </button>
                  </div>
                </div>
              </div>
            )}

            {currentModal === "ag4" && (
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[820px] w-full">
                <div className="bg-white py-5">
                  <div className="mt-3 text-left">
                    <div className="flex justify-between px-5">
                      <h3
                        className="text-base leading-6 font-extrabold"
                        id="modal-title"
                      >
                        개인정보 수집 및 이용 동의
                      </h3>
                      <button type="button" onClick={() => setModalOpen(false)}>
                        <img src="./assets/close.svg" />
                      </button>
                    </div>
                    <div className="border-b border-gray-300 my-5"></div>
                    <div className="mt-2 px-5">
                      <p className="text-[12px] mb-3">
                        [필수] 개인정보 수집 및 이용 동의
                      </p>
                      <table className="min-w-full border-collapse border-t border-b border-gray-200">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200">
                              {" "}
                              항목
                            </th>
                            <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200">
                              {" "}
                              목적
                            </th>
                            <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-gray-200">
                              보유 및 이용기간
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              아이디(이메일), 이름, 휴대폰번호, 비밀번호
                            </td>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              회원 가입 및 이용자 식별, 회원관리
                            </td>
                            <td
                              className="p-2 text-[12px] font-bold border-b border-gray-200"
                              rowspan="2"
                            >
                              회원탈퇴 시 90일 후 파기
                            </td>
                          </tr>
                          <tr>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              아이디(이메일), 이름, 휴대폰번호, 서비스 이용기록,
                              연령 및 성별
                            </td>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              개인화 서비스 제공
                            </td>
                          </tr>
                          <tr>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              부정행위 탐지된 아이디(이메일), 이름, 휴대폰번호,
                              부정행위 기록
                            </td>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              부정행위 방지
                            </td>
                            <td className="p-2 text-[12px] font-bold border-b border-gray-200">
                              회원탈퇴 시 180일간 보관 후 파기
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p className="break-keep text-[10px] text-gray-400 mt-5">
                        연령 및 성별 정보는 회원 가입 이후 본인 확인을 진행한
                        이용자에 한해 활용됩니다.
                      </p>
                      <p className="break-keep text-[10px] text-gray-400 mt-1">
                        동의를 거부할 수 있으나 동의 거부 시 서비스 이용이
                        제한됩니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {currentModal === "ag5" && (
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[620px] w-full">
                <div className="bg-white py-5">
                  <div className="mt-3 text-left">
                    <div className="flex justify-between px-5">
                      <h3
                        className="text-base leading-6 font-extrabold"
                        id="modal-title"
                      >
                        개인정보 제3자 제공 동의
                      </h3>
                      <button type="button" onClick={() => setModalOpen(false)}>
                        <img src="./assets/close.svg" />
                      </button>
                    </div>
                    <div className="border-b border-gray-300 my-5"></div>
                    <div className="mt-2 px-5">
                      <p className="text-[12px] mb-3">
                        [필수] 개인정보 제3자 제공 동의
                      </p>
                      <table className="min-w-full border-collapse border-t border-b border-gray-200">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="p-2 break-keep text-center text-[12px] font-bold border-b border-r border-gray-200">
                              {" "}
                              개인정보 제공 받는자
                            </th>
                            <th className="p-2 break-keep text-center text-[12px] font-bold border-b border-r border-gray-200">
                              개인정보 제공 항목
                            </th>
                            <th className="p-2 break-keep text-center text-[12px] font-bold border-b border-r border-gray-200">
                              개인정보 제공 목적
                            </th>
                            <th className="p-2 break-keep text-center text-[12px] font-bold border-b border-gray-200">
                              개인정보 이용 기간
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="p-2 break-keep text-[12px] border-b border-r border-gray-200">
                              넷스프린트 주식회사
                            </td>
                            <td className="p-2 break-keep text-[12px] border-b border-r border-gray-200">
                              일사 파트너스 아이디
                            </td>
                            <td className="p-2 break-keep text-[12px] border-b border-r border-gray-200">
                              서비스 제공
                            </td>
                            <td className="p-2 break-keep text-[12px] border-b border-gray-200">
                              전자상거래법에 의해 5년간 보관 후 파기
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p className="break-keep text-[10px] text-gray-400 mt-5">
                        제공에 동의하지 않을 수 있으나, 동의하지 않으면 회원
                        가입에 제한이 됩니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {currentModal === "ag6" && (
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[870px] w-full">
                <div className="bg-white py-5">
                  <div className="mt-3 text-left">
                    <div className="flex justify-between px-5">
                      <h3
                        className="text-base leading-6 font-extrabold"
                        id="modal-title"
                      >
                        마케팅 목적 개인정보 수집 및 이용 동의
                      </h3>
                      <button type="button" onClick={() => setModalOpen(false)}>
                        <img src="./assets/close.svg" />
                      </button>
                    </div>
                    <div className="border-b border-gray-300 my-5"></div>
                    <div className="mt-2 px-5">
                      <p className="text-[12px] mb-3">
                        [필수] 마케팅 목적의 개인정보 수집 및 이용 동의
                      </p>
                      <table className="min-w-full border-collapse border-t border-b border-gray-200">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200">
                              {" "}
                              항목
                            </th>
                            <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200">
                              {" "}
                              목적
                            </th>
                            <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-gray-200">
                              보유 및 이용기간
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              서비스 이용기록, 연령 및 성별
                            </td>
                            <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">
                              인구통계학적 특성과 이용자의 관심 및 성향의 추정을
                              통한 맞춤형 광고에 활용
                            </td>
                            <td className="p-2 text-[12px] font-bold border-b border-gray-200">
                              동의 철회 시 맞춤형 광고 차단, 회원 탈퇴 시 파기
                            </td>
                          </tr>
                          <tr>
                            <td className="p-2 text-[12px] border-b border-r border-gray-200">
                              아이디(이메일), 휴대폰번호
                            </td>
                            <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">
                              일사 아이디를 이용하는 서비스의 마케팅 및 프로모션
                            </td>
                            <td className="p-2 text-[12px] font-bold border-b border-gray-200">
                              회원 탈퇴시 파기
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p className="break-keep text-[10px] text-gray-400 mt-5">
                        연령 및 성별 정보는 회원 가입 이후 본인 확인을 진행한
                        이용자에 한해 활용됩니다.
                      </p>
                      <p className="break-keep text-[10px] text-gray-400 mt-1">
                        동의를 거부할 수 있으며, 동의를 거부하셔도 서비스를
                        이용하실 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {currentModal === "ag7" && (
              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[320px] w-full">
                <div className="bg-white py-5">
                  <div className="mt-3 text-left">
                    <div className="flex justify-between px-5">
                      <h3
                        className="text-base leading-6 font-extrabold"
                        id="modal-title"
                      >
                        광고성 정보 수신 동의
                      </h3>
                      <button type="button" onClick={() => setModalOpen(false)}>
                        <img src="./assets/close.svg" />
                      </button>
                    </div>
                    <div className="border-b border-gray-300 my-5"></div>
                    <div className="mt-2 px-5">
                      <p className="text-[12px]">
                        [선택] 광고성 정보 수신 동의
                        <br />
                        <br />
                        일사 파트너스는 회원님이 수집 및 이용에 동의한
                        개인정보를 이용하여 SMS(MMS), SNS 메시지, 이메일, 푸시
                        알림 등 다양한 전자적 전송 매체를 통해 오전 8시부터 오후
                        9시까지 개인 맞춤형 광고 및 정보를 전송할 수 있습니다.
                        <br />
                        <br />
                        본 동의는 거부하실 수 있으나, 거부 시 이벤트 및 프로모션
                        안내, 유용한 광고를 받아보실 수 없습니다.
                        <br />
                        <br />
                        광고성정보수신의 변경은 일사 파트너스
                        고객센터(1566-1013, customer@ilsaram.co.kr)로
                        요청해주시면 변경이 가능합니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </main>
    </>
  );
};

export default SignUp;
